/* Inline product zoom; kept independent of the review-media lightbox. */
const rhpInitInlineGalleryZoom=(frame,trigger,getImage)=>{
  const isSpanish=document.documentElement.lang.toLowerCase().startsWith('es');
  const stage=document.createElement('div');stage.className='catalog-inline-zoom';stage.hidden=true;
  const image=document.createElement('img');image.draggable=false;stage.append(image);
  const controls=document.createElement('div');controls.className='catalog-inline-zoom-controls';controls.hidden=true;
  controls.setAttribute('role','toolbar');controls.setAttribute('aria-label',isSpanish?'Controles de ampliación de imagen':'Image zoom controls');
  const icons={in:'<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/>',out:'<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35M8 11h6"/>',full:'<path d="M3 8V3h5M16 3h5v5M21 16v5h-5M8 21H3v-5"/>',close:'<path d="m6 6 12 12M6 18 18 6"/>'};
  const buttons={};
  for(const [action,label] of [['in','Zoom in'],['out','Zoom out'],['full','Fullscreen'],['close','Close image zoom']]){
    const localizedLabel=isSpanish?({in:'Ampliar',out:'Reducir',full:'Pantalla completa',close:'Cerrar ampliación'})[action]:label;
    const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',localizedLabel);button.title=localizedLabel;
    button.innerHTML=`<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${icons[action]}</svg>`;
    controls.append(button);buttons[action]=button;
  }
  const hint=document.createElement('div');hint.className='catalog-inline-zoom-hint';hint.hidden=true;
  frame.append(stage);stage.append(controls,hint);
  let opened=false,fullscreen=false,scale=1,x=0,y=0,drag=null,hintTimer,previousOverflow='';
  const apply=()=>{
    const bounds=stage.getBoundingClientRect();
    const ratio=image.naturalWidth&&image.naturalHeight?Math.min(image.clientWidth/image.naturalWidth,image.clientHeight/image.naturalHeight):1;
    const maxX=Math.max(0,((image.naturalWidth||image.clientWidth)*ratio*scale-bounds.width)/2);
    const maxY=Math.max(0,((image.naturalHeight||image.clientHeight)*ratio*scale-bounds.height)/2);
    x=Math.max(-maxX,Math.min(maxX,x));y=Math.max(-maxY,Math.min(maxY,y));
    image.style.transform=`translate(${x}px,${y}px) scale(${scale})`;
    image.style.transition=drag?'none':'transform .2s ease-out';
    stage.style.cursor=scale>1?(drag?'grabbing':'grab'):'zoom-in';
    stage.dataset.zoomScale=String(scale);
    buttons.in.disabled=scale>=3;buttons.out.disabled=scale<=1;
  };
  const setFullscreen=value=>{
    const focusedControl=controls.contains(document.activeElement)?document.activeElement:null;
    fullscreen=value;stage.classList.toggle('is-fullscreen',value);
    buttons.full.setAttribute('aria-label',value?'Exit fullscreen':'Fullscreen');
    buttons.full.title=value?'Exit fullscreen':'Fullscreen';buttons.full.setAttribute('aria-pressed',String(value));
    if(value){previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';document.body.append(stage);stage.setAttribute('role','dialog');stage.setAttribute('aria-modal','true');stage.setAttribute('aria-label','Product image zoom');stage.append(controls)}
    else{document.body.style.overflow=previousOverflow;frame.append(stage);stage.removeAttribute('role');stage.removeAttribute('aria-modal')}
    scale=1;x=0;y=0;apply();
    focusedControl?.focus({preventScroll:true});
  };
  const close=(restoreFocus=true)=>{
    if(!opened)return;
    opened=false;drag=null;window.clearTimeout(hintTimer);hint.hidden=true;
    if(fullscreen)setFullscreen(false);
    stage.hidden=true;controls.hidden=true;trigger.hidden=false;frame.classList.remove('has-inline-zoom');
    scale=1;x=0;y=0;apply();
    if(restoreFocus&&trigger.isConnected)trigger.focus({preventScroll:true});
  };
  const open=()=>{
    if(opened)return;
    const selected=getImage();image.src=selected.src;image.alt=selected.alt;
    const touch=window.matchMedia('(hover: none), (pointer: coarse)').matches;
    opened=true;scale=1.5;x=0;y=0;stage.hidden=false;controls.hidden=false;trigger.hidden=true;frame.classList.add('has-inline-zoom');apply();
    hint.textContent=touch?'Drag to move · Use + / − to zoom':'Use scroll wheel to zoom';hint.hidden=false;
    hintTimer=window.setTimeout(()=>{hint.hidden=true},2000);buttons.close.focus({preventScroll:true});
  };
  trigger.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();open()});
  let imagePress=null,suppressImageClick=false;
  frame.addEventListener('pointerdown',event=>{imagePress={x:event.clientX,y:event.clientY};suppressImageClick=false},{capture:true});
  frame.addEventListener('pointerup',event=>{if(imagePress)suppressImageClick=Math.hypot(event.clientX-imagePress.x,event.clientY-imagePress.y)>8;imagePress=null},{capture:true});
  frame.addEventListener('pointercancel',()=>{imagePress=null;suppressImageClick=true},{capture:true});
  frame.addEventListener('click',event=>{
    if(suppressImageClick)return;
    if(event.target.matches('[data-catalog-main-image]'))open();
    else if(event.target.matches('.catalog-mobile-track>img')){
      const selected=getImage();
      if(event.target.src===new URL(selected.src,window.location.href).href)open();
    }
  });
  buttons.in.addEventListener('click',()=>{scale=Math.min(3,Math.round((scale+.1)*10)/10);apply()});
  buttons.out.addEventListener('click',()=>{scale=Math.max(1,Math.round((scale-.1)*10)/10);apply()});
  buttons.full.addEventListener('click',()=>setFullscreen(!fullscreen));
  buttons.close.addEventListener('click',()=>close());
  image.addEventListener('load',apply);
  window.addEventListener('resize',()=>{if(opened){drag=null;apply()}});
  window.addEventListener('pagehide',()=>close(false));
  controls.addEventListener('click',event=>event.stopPropagation());
  stage.addEventListener('pointerdown',event=>{
    if(event.target.closest('button')||event.isPrimary===false||event.button>0||scale<=1)return;
    event.preventDefault();event.stopPropagation();drag={id:event.pointerId,px:event.clientX,py:event.clientY,x,y};stage.setPointerCapture?.(event.pointerId);apply();
  });
  stage.addEventListener('pointermove',event=>{if(!drag||drag.id!==event.pointerId)return;event.preventDefault();event.stopPropagation();x=drag.x+event.clientX-drag.px;y=drag.y+event.clientY-drag.py;apply()});
  const release=event=>{if(!drag||drag.id!==event.pointerId)return;drag=null;apply()};
  for(const name of ['pointerup','pointercancel','lostpointercapture'])stage.addEventListener(name,release);
  stage.addEventListener('wheel',event=>{
    if(!opened||event.target.closest('button'))return;
    event.preventDefault();event.stopPropagation();const r=stage.getBoundingClientRect(),old=scale;
    scale=Math.max(1,Math.min(3,Math.round((scale+(event.deltaY<0?.1:-.1))*10)/10));
    x-=(event.clientX-r.left-r.width/2)*(scale-old)/old;y-=(event.clientY-r.top-r.height/2)*(scale-old)/old;apply();
  },{passive:false});
  document.addEventListener('keydown',event=>{
    if(!opened)return;
    if(event.key==='Escape'){event.preventDefault();close();return}
    if(fullscreen&&event.key==='Tab'){
      const available=Object.values(buttons).filter(button=>!button.disabled),first=available[0],last=available.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
    }
  });
  return close;
};

const rhpSetupScrollHeader=()=>{
  let headerSection=null;
  try{headerSection=document.querySelector('.shopify-section:has(> .urgency-banner)')}catch(error){headerSection=null}
  if(!headerSection){
    headerSection=Array.from(document.querySelectorAll('.shopify-section')).find(section=>Array.from(section.children).some(child=>child.classList.contains('urgency-banner')))||null;
  }
  if(!headerSection||headerSection.dataset.rhpScrollHeaderReady)return;
  headerSection.dataset.rhpScrollHeaderReady='true';
  headerSection.classList.add('rhp-header-section');
  if(headerSection.querySelector('.site-header--red')){
    const announcement=headerSection.querySelector('.urgency-banner');
    const measureAnnouncement=()=>headerSection.style.setProperty('--rhp-announcement-height',`${announcement?.getBoundingClientRect().height||0}px`);
    headerSection.classList.add('rhp-header-pinned');
    headerSection.classList.remove('rhp-header-hidden');
    measureAnnouncement();
    if(announcement&&'ResizeObserver' in window)new ResizeObserver(measureAnnouncement).observe(announcement);
    else window.addEventListener('resize',measureAnnouncement,{passive:true});
    return;
  }
  const scrollContainer=document.querySelector('.page-wrapper');
  const scrollTarget=scrollContainer&&scrollContainer.scrollHeight>scrollContainer.clientHeight+8?scrollContainer:window;
  const getScrollY=()=>Math.max(0,scrollTarget===window?window.scrollY||document.documentElement.scrollTop||0:scrollTarget.scrollTop||0);
  let lastScrollY=getScrollY();
  let headerState=lastScrollY<=8?'top':'';
  let ticking=false;
  const updateHeader=()=>{
    ticking=false;
    const currentScrollY=getScrollY();
    const delta=currentScrollY-lastScrollY;
    const nextState=currentScrollY<=8?'top':delta<0?'up':delta>2?'hidden':headerState;
    if(nextState!==headerState){
      if(nextState==='hidden')headerSection.classList.add('rhp-header-hidden');
      else headerSection.classList.remove('rhp-header-hidden');
      headerState=nextState;
    }
    lastScrollY=currentScrollY;
  };
  scrollTarget.addEventListener('scroll',()=>{
    if(!ticking){ticking=true;window.requestAnimationFrame(updateHeader)}
  },{passive:true});
};

const rhpInitializeReasons=(scope=document)=>{
  const roots=[];
  if(scope.matches?.('[data-lohriz-reasons]'))roots.push(scope);
  scope.querySelectorAll?.('[data-lohriz-reasons]').forEach(root=>roots.push(root));
  roots.forEach(root=>{
    if(root.dataset.lohrizReasonsReady==='true')return;
    root.dataset.lohrizReasonsReady='true';
    const video=root.querySelector('[data-lohriz-reasons-video]');
    if(!video)return;
    const soundButton=root.querySelector('[data-lohriz-reasons-sound]');
    const playButton=root.querySelector('[data-lohriz-reasons-play]');
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const shouldAutoplay=root.dataset.autoplay==='true'&&!reducedMotion;
    let loaded=false;
    const videoStatus=["red-bull-extreme-honey","loriz-premium-shilajit-honey","premium-honey-sachets-individually-packed","php-royal-honey-supplement"].includes(root.dataset.productHandle)?document.createElement('p'):null;
    if(videoStatus){
      videoStatus.className='lohriz-reasons__video-status';
      videoStatus.setAttribute('role','status');
      videoStatus.hidden=true;
      root.querySelector('.lohriz-reasons__media')?.append(videoStatus);
    }
    const reportVideoError=()=>{
      if(videoStatus){videoStatus.textContent='Video could not play. Select play to try again.';videoStatus.hidden=false;}
      updatePlayback();
    };
    const clearVideoError=()=>{if(videoStatus){videoStatus.textContent='';videoStatus.hidden=true;}};

    const updateSound=()=>{
      const muted=video.muted;
      soundButton?.setAttribute('aria-label',muted?'Unmute video':'Mute video');
      soundButton?.setAttribute('aria-pressed',muted?'false':'true');
      soundButton?.querySelector('[data-icon-muted]')?.toggleAttribute('hidden',!muted);
      soundButton?.querySelector('[data-icon-unmuted]')?.toggleAttribute('hidden',muted);
    };
    const updatePlayback=()=>{
      const paused=video.paused;
      playButton?.setAttribute('aria-label',paused?'Play video':'Pause video');
      playButton?.setAttribute('aria-pressed',paused?'false':'true');
      playButton?.querySelector('[data-icon-pause]')?.toggleAttribute('hidden',paused);
      playButton?.querySelector('[data-icon-play]')?.toggleAttribute('hidden',!paused);
    };
    const loadVideo=playAfterLoad=>{
      if(!loaded){
        video.querySelectorAll('source[data-src]').forEach(source=>{
          source.src=source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.preload='metadata';
        video.load();
        loaded=true;
      }
      if(playAfterLoad)video.play().catch(updatePlayback);
    };

    if(reducedMotion){
      video.removeAttribute('autoplay');
      video.pause();
    }
    soundButton?.addEventListener('click',()=>{
      loadVideo(false);
      video.muted=!video.muted;
      updateSound();
    });
    playButton?.addEventListener('click',()=>{
      loadVideo(false);
      if(video.paused){
        clearVideoError();
        if(video.error||video.networkState===3){loaded=false;loadVideo(false);}
        video.play().catch(error=>{if(error?.name!=='AbortError')reportVideoError();else updatePlayback();});
      }else video.pause();
    });
    video.addEventListener('error',reportVideoError);
    video.querySelectorAll('source').forEach(source=>source.addEventListener('error',()=>{
      if(video.networkState===3)reportVideoError();
    }));
    video.addEventListener('playing',clearVideoError);
    video.addEventListener('play',updatePlayback);
    video.addEventListener('pause',updatePlayback);
    video.addEventListener('volumechange',updateSound);
    updateSound();
    updatePlayback();

    if('IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)){
          observer.disconnect();
          loadVideo(shouldAutoplay);
        }
      },{rootMargin:'500px 0px'});
      observer.observe(root);
    }else{
      loadVideo(shouldAutoplay);
    }
  });
};

const rhpInitialize=()=>{
  rhpSetupScrollHeader();
  rhpInitializeReasons();
  // Keep the cart link as a no-script fallback, while opening the drawer when
  // the normal cart initializer is unavailable during a partial theme load.
  const rhpCartTriggerRoot=document.documentElement;
  if(!rhpCartTriggerRoot.dataset.rhpCartTriggerReady){
    rhpCartTriggerRoot.dataset.rhpCartTriggerReady='true';
    const setDrawerOpen=open=>{
      const drawer=document.querySelector('[data-rhp-cart-drawer]');
      if(!drawer)return;
      drawer.hidden=!open;
      drawer.setAttribute('aria-hidden',open?'false':'true');
      document.body.classList.toggle('rhp-cart-drawer-open',open);
      const applyState=()=>drawer.classList.toggle('is-open',open);
      if(open&&typeof window.requestAnimationFrame==='function')window.requestAnimationFrame(applyState);else applyState();
    };
    document.addEventListener('click',event=>{
      if(event.defaultPrevented)return;
      const trigger=event.target?.closest?.('[data-rhp-cart-open]');
      if(trigger){
        event.preventDefault();
        if(typeof window.rhpCartOpen==='function')window.rhpCartOpen();
        else setDrawerOpen(true);
        return;
      }
      if(event.target?.closest?.('[data-rhp-cart-close]'))setDrawerOpen(false);
    });
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&typeof window.rhpCartClose!=='function')setDrawerOpen(false)});
  }
  if(document.documentElement.lang.startsWith('es')&&location.pathname.toLowerCase().includes('/apps/17track')){
    const localizeTrackingButton=()=>document.querySelectorAll('button').forEach(button=>{if(button.textContent.trim()==='PISTA')button.textContent='RASTREAR'});
    localizeTrackingButton();
    const trackingObserver=new MutationObserver(localizeTrackingButton);
    trackingObserver.observe(document.body,{childList:true,subtree:true});
    window.setTimeout(()=>trackingObserver.disconnect(),10000);
  }
  const rhpCartDrawer=document.querySelector('[data-rhp-cart-drawer]');
  if(rhpCartDrawer){
    const rhpCartPanel=rhpCartDrawer.querySelector('.rhp-cart-drawer__panel');
    const rhpCartItems=rhpCartDrawer.querySelector('[data-rhp-cart-items]');
    const rhpCartSummary=rhpCartDrawer.querySelector('[data-rhp-cart-summary]');
    const rhpCartEmptyMarkup=rhpCartDrawer.querySelector('[data-rhp-cart-empty]')?.outerHTML||'';
    const rhpCartCrossSell=rhpCartDrawer.querySelector('[data-rhp-cart-cross-sell]');
    const rhpIsSpanish=document.documentElement.lang.startsWith('es');
    const rhpCurrency=()=>rhpLatestCart?.currency||window.Shopify?.currency?.active||'USD';
    const rhpMoney=cents=>new Intl.NumberFormat(rhpIsSpanish?'es-MX':'en-US',{style:'currency',currency:rhpCurrency()}).format(Number(cents||0)/100);
    const rhpEscapeHtml=value=>String(value??'').replace(/[&<>'"]/g,character=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
    const rhpGiftImage=rhpCartDrawer.dataset.rhpGiftImage||'';
    const rhpGiftCopy=rhpIsSpanish?{
      title:'Regalo misterioso',included:'Incluido',free:'Gratis',quantityLabel:'Cantidad: 1',
      standard:'Sorpresa de cortesía con este pedido',subscription:'Incluido solo con el primer pedido de la suscripción · Las renovaciones no incluyen regalo'
    }:{
      title:'Mystery Gift',included:'Included',free:'Free',quantityLabel:'Quantity: 1',
      standard:'Complimentary surprise with this order',subscription:'Included with the first subscription order only · Renewals do not include a gift'
    };
    let rhpRestoringFocus=null;
    let rhpCloseTimer;
    let rhpLatestCart=null;
    const rhpSetOpen=(open,returnFocus)=>{
      window.clearTimeout(rhpCloseTimer);
      if(open){
        rhpRestoringFocus=returnFocus||document.activeElement;
        rhpCartDrawer.hidden=false;
        rhpCartDrawer.setAttribute('aria-hidden','false');
        document.body.classList.add('rhp-cart-drawer-open');
        requestAnimationFrame(()=>rhpCartDrawer.classList.add('is-open'));
        window.setTimeout(()=>rhpCartDrawer.querySelector('.rhp-cart-drawer__close')?.focus(),30);
      }else{
        rhpCartDrawer.classList.remove('is-open');
        rhpCartDrawer.setAttribute('aria-hidden','true');
        document.body.classList.remove('rhp-cart-drawer-open');
        rhpCloseTimer=window.setTimeout(()=>{rhpCartDrawer.hidden=true},230);
        const focusTarget=rhpRestoringFocus?.isConnected&&rhpRestoringFocus!==document.body?rhpRestoringFocus:document.querySelector('[data-rhp-cart-open]');
        focusTarget?.focus?.({preventScroll:true});
      }
    };
    const rhpGiftVariantId=Number(rhpCartDrawer.dataset.rhpGiftVariantId||0);
    const rhpIsGiftLine=line=>Number(line.variant_id||line.id||0)===rhpGiftVariantId||line.handle==='mystery-gift'||line.product_handle==='mystery-gift'||String(line.product_title||line.title||'').toLowerCase().includes('mystery gift');
    const rhpBoxCount=line=>{
      if(rhpIsGiftLine(line))return 0;
      const quantity=Math.max(0,Number(line.quantity||0));
      const handle=String(line.handle||line.product_handle||'');
      if(Number(line.product_id)===16029390405713||handle.includes('stick'))return 0;
      const shilajitBoxes={60503760142417:1,60503760175185:3,60503760207953:5};
      const boxes=shilajitBoxes[Number(line.variant_id||line.id||0)];
      if(boxes)return quantity*boxes;
      const bundle=String(line.variant_title||'').match(/buy\s*(\d+)\s*get\s*(\d+)/i);
      if(bundle)return quantity*(Number(bundle[1])+Number(bundle[2]));
      const match=String(line.variant_title||'').match(/(\d+)\s*box(?:es)?/i);
      return quantity*(match?Math.max(1,Number(match[1])):1);
    };
    const rhpQualifiesForGift=line=>rhpBoxCount(line)>=2;
    const rhpRenderRow=(line,isGift=false,giftKind='standard')=>{
      const title=isGift?rhpGiftCopy.title:(line.product_title||line.title||'Item');
      const key=line.key||line.id||'';
      const url=line.url||'#';
      const imageSource=isGift?(line.image||rhpGiftImage):line.image;
      const image=imageSource?`<img src="${rhpEscapeHtml(imageSource)}" alt="" width="78" height="78" loading="lazy">`:'';
      const variant=isGift?'':String(line.variant_title||'').replace(/^Default Title$/i,'');
      const plan=line.selling_plan_allocation?.selling_plan?.name||'';
      const details=[variant,plan].filter(Boolean).map(rhpEscapeHtml).join('<br>');
      const price=isGift?rhpGiftCopy.free:rhpMoney(line.final_line_price??line.line_price??0);
      const quantity=isGift?`<div class="rhp-cart-gift__fixed-quantity" role="group" aria-label="${rhpGiftCopy.quantityLabel}"><span aria-hidden="true">✓</span><span>${rhpGiftCopy.included}</span></div>`:`<div class="rhp-cart-quantity"><button type="button" data-rhp-qty-minus data-rhp-key="${rhpEscapeHtml(key)}" aria-label="Decrease quantity"><span aria-hidden="true">−</span><span class="visually-hidden">Decrease quantity</span></button><input type="number" min="1" step="1" value="${Math.max(1,Number(line.quantity||1))}" data-rhp-qty-input data-rhp-key="${rhpEscapeHtml(key)}" aria-label="Quantity"><button type="button" data-rhp-qty-plus data-rhp-key="${rhpEscapeHtml(key)}" aria-label="Increase quantity"><span aria-hidden="true">+</span><span class="visually-hidden">Increase quantity</span></button></div>`;
      const remove=isGift?'':`<button class="rhp-cart-row__remove" type="button" data-rhp-cart-remove="${rhpEscapeHtml(key)}" aria-label="Remove ${rhpEscapeHtml(title)}"><svg aria-hidden="true" viewBox="0 0 20 20"><path d="M11.5 9v4.25M8.5 9v4.25M5.75 6v6.2c0 .85 0 1.45.21 1.91.2.4.6.8.98 1.02.2.1.46.17.91.2.46.04 1.06.04 1.91.04h.4c.85 0 1.45 0 1.91-.04.45-.04.71-.1.91-.2.4-.2.8-.6.98-1.02.1-.2.17-.46.21-.91V6M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0"/></svg><span class="visually-hidden">Remove</span></button>`;
      const giftSubtitle=giftKind==='subscription'?rhpGiftCopy.subscription:rhpGiftCopy.standard;
      return `<div class="rhp-cart-row ${isGift?'rhp-cart-gift':''}" role="row" data-rhp-cart-row data-rhp-key="${rhpEscapeHtml(key)}"><div class="rhp-cart-row__media" role="cell">${isGift?`<span class="rhp-cart-gift__media">${image}</span>`:`<a class="rhp-cart-row__media-link" href="${rhpEscapeHtml(url)}">${image}</a>`}</div><div class="rhp-cart-row__details" role="cell">${isGift?`<span class="rhp-cart-row__title">${rhpEscapeHtml(title)}</span>`:`<a class="rhp-cart-row__title" href="${rhpEscapeHtml(url)}">${rhpEscapeHtml(title)}</a>`}${isGift?`<p class="rhp-cart-gift__subtitle">${rhpEscapeHtml(giftSubtitle)}</p>`:(details?`<p class="rhp-cart-row__variant">${details}</p>`:'')}</div><div class="rhp-cart-row__quantity" role="cell">${quantity}</div>${remove}<div class="rhp-cart-row__price" role="cell">${price}</div></div>`;
    };
    const rhpRenderCart=cart=>{
      rhpLatestCart=cart||{items:[]};
      const lines=Array.isArray(rhpLatestCart.items)?rhpLatestCart.items:[];
      const realLines=lines.filter(line=>!rhpIsGiftLine(line));
      const hasGiftLine=lines.some(rhpIsGiftLine);
      const totalBoxes=realLines.reduce((sum,line)=>sum+rhpBoxCount(line),0);
      const qualifies=totalBoxes>=2;
      const giftKind=qualifies&&realLines.length&&realLines.every(line=>line.selling_plan_allocation)?'subscription':'standard';
      if(rhpCartItems){
        if(!lines.length){
          rhpCartItems.innerHTML=rhpCartEmptyMarkup;
          rhpCartItems.querySelector('[data-rhp-cart-empty]')?.removeAttribute('hidden');
        }else{
          const orderedLines=[...realLines,...lines.filter(rhpIsGiftLine)];
          const rows=orderedLines.map(line=>rhpRenderRow(line,rhpIsGiftLine(line),giftKind));
          rhpCartItems.innerHTML=`<div class="rhp-cart-items-table" role="table"><div class="rhp-cart-items-table__body" role="rowgroup">${rows.join('')}</div></div>`;
        }
      }
      const subtotal=Number(rhpLatestCart.items_subtotal_price??rhpLatestCart.original_total_price??rhpLatestCart.total_price??0);
      const total=Number(rhpLatestCart.total_price??0);
      const shipping=rhpCartDrawer.querySelector('[data-rhp-cart-shipping]');
      if(shipping){
        const eyebrow=shipping.querySelector('[data-rhp-shipping-eyebrow]');
        const message=shipping.querySelector('[data-rhp-shipping-message]');
        const goalText=shipping.querySelector('[data-rhp-shipping-goal]');
        if(eyebrow){eyebrow.textContent='';eyebrow.hidden=true;}
        const usd=rhpCurrency()==='USD';
        const remaining=Math.max(0,5900-total);
        const progress=Math.min(100,Math.max(0,total/5900*100));
        if(message)message.textContent=usd?(remaining>0?(rhpIsSpanish?`Añade ${rhpMoney(remaining)} para alcanzar el envío estándar gratis en EE. UU.`:`You're ${rhpMoney(remaining)} away from free US standard shipping`):(rhpIsSpanish?'¡Has alcanzado el mínimo para envío estándar gratis en EE. UU.!':'You’ve reached the free US standard shipping threshold!')):(rhpIsSpanish?'Envío estándar gratis en EE. UU. desde $59 USD después de descuentos':'Free US standard shipping on $59 USD after discounts');
        const track=shipping.querySelector('[data-rhp-shipping-track]');
        if(track){track.hidden=!usd;track.setAttribute('aria-valuenow',String(Math.round(progress)));track.style.setProperty('--rhp-cart-drawer-progress',`${progress}%`);}
        if(goalText){goalText.textContent='';goalText.hidden=true;}
        const labels=shipping.querySelector('[data-rhp-shipping-labels]');
        if(labels)labels.hidden=!usd;
      }
      if(rhpCartSummary){
        rhpCartSummary.hidden=!realLines.length;
        const subtotalNode=rhpCartSummary.querySelector('[data-rhp-cart-subtotal]');
        const totalNode=rhpCartSummary.querySelector('[data-rhp-cart-total]');
        if(subtotalNode)subtotalNode.textContent=rhpMoney(subtotal);
        if(totalNode)totalNode.textContent=`${rhpMoney(total)} ${rhpCurrency()}`;
        const discountsNode=rhpCartSummary.querySelector('[data-rhp-cart-discounts]');
        if(discountsNode){
          const discounts=Array.isArray(rhpLatestCart.cart_level_discount_applications)?rhpLatestCart.cart_level_discount_applications:[];
          const fallback=!discounts.length&&Number(rhpLatestCart.total_discount||0)>0?[{title:rhpIsSpanish?'Descuento':'Discount',total_allocated_amount:Number(rhpLatestCart.total_discount)}]:discounts;
          discountsNode.innerHTML=fallback.map(discount=>{const title=String(discount.title||'');const displayTitle=/^welcome25$/i.test(title)?(rhpIsSpanish?'OFERTA DE BIENVENIDA':'WELCOME OFFER'):(title||'Discount');return `<li><span><svg aria-hidden="true" viewBox="0 0 24 24"><path d="m20 13-7 7-9-9V4h7l9 9Z"/><circle cx="8" cy="8" r="1"/></svg>${rhpEscapeHtml(displayTitle)}</span><strong>-${rhpMoney(discount.total_allocated_amount||discount.amount||0)}</strong></li>`}).join('');
          discountsNode.hidden=!fallback.length;
        }
      }
      if(rhpCartCrossSell){
        const family=(handle,title='')=>{
          const value=`${handle} ${title}`.toLowerCase();
          if(/platinum|premium-honey-sachets/.test(value))return 'platinum';
          if(/black.*honey|black-bull/.test(value))return 'black';
          if(/shilajit/.test(value))return 'shilajit';
          if(/php-royal|royal honey/.test(value))return 'royal';
          if(/rhino/.test(value))return 'rhino';
          return handle;
        };
        const candidate=[...rhpCartDrawer.querySelectorAll('[data-cart-candidate]')].find(node=>!realLines.some(line=>String(line.product_id)===node.dataset.rhpProductId||family(line.handle||'',line.product_title||line.title||'')===family(node.dataset.rhpProductHandle,node.dataset.rhpProductTitle)));
        if(candidate)Object.assign(rhpCartCrossSell.dataset,candidate.dataset);
        else rhpCartCrossSell.dataset.rhpVariantId='';
        const crossVariantId=Number(rhpCartCrossSell.dataset.rhpVariantId||0);
        const alreadyInCart=lines.some(line=>Number(line.variant_id||line.id)===crossVariantId);
        const canShow=realLines.length>0&&crossVariantId>0&&!alreadyInCart;
        rhpCartCrossSell.hidden=!canShow;
        if(canShow){
          const imageNode=rhpCartCrossSell.querySelector('[data-rhp-cross-sell-image]');
          const linkNodes=rhpCartCrossSell.querySelectorAll('[data-rhp-cross-sell-link],[data-rhp-cross-sell-title]');
          const imageUrl=rhpCartCrossSell.dataset.rhpProductImage||'';
          const productUrl=rhpCartCrossSell.dataset.rhpProductUrl||'#';
          if(imageNode){imageNode.src=imageUrl;imageNode.alt=rhpCartCrossSell.dataset.rhpProductTitle||'';}
          linkNodes.forEach(link=>link.href=productUrl);
          const titleNode=rhpCartCrossSell.querySelector('[data-rhp-cross-sell-title]');
          const variantNode=rhpCartCrossSell.querySelector('[data-rhp-cross-sell-variant]');
          const priceNode=rhpCartCrossSell.querySelector('[data-rhp-cross-sell-price]');
          const regularNode=rhpCartCrossSell.querySelector('[data-rhp-cross-sell-regular]');
          const discountNode=rhpCartCrossSell.querySelector('[data-rhp-cross-sell-discount]');
          const savingsNode=rhpCartCrossSell.querySelector('[data-rhp-cross-sell-savings]');
          const price=Number(rhpCartCrossSell.dataset.rhpPriceCents||0); const compare=Number(rhpCartCrossSell.dataset.rhpCompareCents||0); const saved=Math.max(0,compare-price); const percent=compare>price?Math.round(saved/compare*100):0;
          if(titleNode)titleNode.textContent=rhpCartCrossSell.dataset.rhpProductTitle||'';
          if(variantNode){const variantTitle=(rhpCartCrossSell.dataset.rhpVariantTitle||'').trim();const meaningful=variantTitle&&!/^default title$/i.test(variantTitle);variantNode.textContent=meaningful?variantTitle:'';variantNode.hidden=!meaningful;}
          if(priceNode)priceNode.textContent=rhpMoney(price);
          if(regularNode){regularNode.textContent=compare>price?rhpMoney(compare):'';regularNode.hidden=!(compare>price);}
          if(discountNode)discountNode.textContent=percent?`${percent}% OFF`:'';
          if(savingsNode)savingsNode.textContent=percent?`${rhpIsSpanish?'Ahorra':'Save'} ${rhpMoney(saved)}`:'';
        }
      }
      document.querySelectorAll('[data-cart-count]').forEach(count=>{const countValue=Number(rhpLatestCart.item_count??realLines.length);count.textContent=countValue;count.classList.toggle('is-empty',countValue<1);const link=count.closest('.cart-link');link?.setAttribute('aria-label',`${rhpIsSpanish?'Carrito':'Cart'} (${countValue})`)});
      const badge=rhpCartDrawer.querySelector('[data-rhp-cart-badge]');
      if(badge)badge.textContent=rhpLatestCart.item_count??realLines.length;
      const countLabel=rhpCartDrawer.querySelector('[data-rhp-cart-count-label]');
      if(countLabel)countLabel.textContent=`${rhpIsSpanish?'Total de artículos en el carrito':'Total items in cart'}: ${rhpLatestCart.item_count??realLines.length}`;
    };
    let rhpGiftSyncPromise=null;
    const rhpFetchCart=async()=>{
      const response=await fetch('/cart.js',{headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('Cart could not be loaded');
      return response.json();
    };
    const rhpSyncGift=async cart=>{
      if(!rhpGiftVariantId)return cart;
      if(rhpGiftSyncPromise)return rhpGiftSyncPromise;
      rhpGiftSyncPromise=(async()=>{
        const lines=Array.isArray(cart.items)?cart.items:[];
        const realLines=lines.filter(line=>!rhpIsGiftLine(line));
        const totalBoxes=realLines.reduce((sum,line)=>sum+rhpBoxCount(line),0);
        const giftLines=lines.filter(rhpIsGiftLine);
        if(totalBoxes>=2&&!giftLines.length){
          const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:rhpGiftVariantId,quantity:1}]})});
          if(!response.ok)throw new Error('Gift add failed');
          return rhpFetchCart();
        }
        if(totalBoxes>=2&&giftLines.length){
          let changed=false;
          const [primaryGift,...duplicateGifts]=giftLines;
          if(Number(primaryGift.quantity||0)!==1){
            const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:primaryGift.key,quantity:1})});
            if(!response.ok)throw new Error('Gift quantity failed');
            changed=true;
          }
          for(const line of duplicateGifts){
            const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
            if(!response.ok)throw new Error('Duplicate gift removal failed');
            changed=true;
          }
          if(changed)return rhpFetchCart();
        }
        if(totalBoxes<2&&giftLines.length){
          for(const line of giftLines){
            const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.key,quantity:0})});
            if(!response.ok)throw new Error('Gift remove failed');
          }
          return rhpFetchCart();
        }
        return cart;
      })().finally(()=>{rhpGiftSyncPromise=null});
      return rhpGiftSyncPromise;
    };
    const rhpRefreshCart=async()=>{
      const initialCart=await rhpFetchCart();
      const cart=await rhpSyncGift(initialCart);
      if(cart!==initialCart&&document.querySelector('[data-rhp-cart-page]')){window.location.reload();return cart;}
      rhpRenderCart(cart);
      return cart;
    };
    let rhpCartOpenRequest=null;
    const rhpOpenCart=(skipRefresh,returnFocus=document.activeElement)=>{
      if(skipRefresh){rhpSetOpen(true,returnFocus);return Promise.resolve();}
      if(rhpCartOpenRequest)return rhpCartOpenRequest;
      rhpCartOpenRequest=rhpRefreshCart().then(()=>rhpSetOpen(true,returnFocus)).catch(()=>{window.location.assign('/cart');}).finally(()=>{rhpCartOpenRequest=null});
      return rhpCartOpenRequest;
    };
    const rhpCloseCart=()=>rhpSetOpen(false);
    window.rhpCartRender=rhpRenderCart;
    window.rhpCartRefresh=rhpRefreshCart;
    window.rhpCartOpen=()=>rhpOpenCart(true);
    window.rhpCartClose=rhpCloseCart;
    document.querySelectorAll('[data-rhp-cart-open]').forEach(button=>button.addEventListener('click',event=>{event.preventDefault();rhpOpenCart(false,event.currentTarget)}));
    const rhpCartMutationStatus=document.createElement('p');
    rhpCartMutationStatus.setAttribute('role','alert');
    rhpCartMutationStatus.setAttribute('data-rhp-cart-mutation-status','');
    rhpCartMutationStatus.hidden=true;
    rhpCartMutationStatus.style.cssText='margin:12px 16px;color:#b42318;font-size:14px;line-height:1.4';
    rhpCartDrawer.querySelector('.rhp-cart-drawer__header')?.after(rhpCartMutationStatus);
    const rhpCartMutationMessage=message=>{
      rhpCartMutationStatus.textContent=message;
      rhpCartMutationStatus.hidden=!message;
    };
    let rhpCartMutationBusy=false;
    const rhpChangeDrawerCart=async(key,quantity,origin)=>{
      if(rhpCartMutationBusy||!key)return;
      const restoreFocus=origin&&document.activeElement===origin;
      rhpCartMutationBusy=true;
      rhpCartMutationMessage('');
      const controls=Array.from(rhpCartDrawer.querySelectorAll('[data-rhp-cart-remove],[data-rhp-qty-minus],[data-rhp-qty-plus],[data-rhp-qty-input],[data-rhp-cross-sell-add]')).map(control=>({control,disabled:control.disabled}));
      controls.forEach(({control})=>{control.disabled=true});
      rhpCartDrawer.setAttribute('aria-busy','true');
      try{
        const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
        if(!response.ok)throw new Error('Cart update failed');
        try{await rhpRefreshCart();}catch{window.location.assign('/cart');}
      }catch{
        rhpCartMutationMessage(rhpIsSpanish?'No se pudo confirmar el cambio. Revisa tu carrito antes de volver a intentarlo.':'Could not confirm the update. Check your cart before trying again.');
      }finally{
        controls.forEach(({control,disabled})=>{if(control.isConnected){control.disabled=disabled;if(control.matches('[data-rhp-qty-input]'))control.value=control.defaultValue;}});
        rhpCartDrawer.removeAttribute('aria-busy');
        rhpCartMutationBusy=false;
        if(restoreFocus&&rhpCartDrawer.classList.contains('is-open')&&(document.activeElement===document.body||document.activeElement===origin)){
          const selector=origin.matches('[data-rhp-qty-plus]')?'[data-rhp-qty-plus]':origin.matches('[data-rhp-qty-minus]')?'[data-rhp-qty-minus]':'[data-rhp-qty-input]';
          const row=rhpCartDrawer.querySelector(`[data-rhp-cart-row][data-rhp-key="${CSS.escape(key)}"]`);
          const focusTarget=(origin.isConnected?origin:row?.querySelector(selector))||rhpCartDrawer.querySelector(selector)||rhpCartDrawer.querySelector('[data-rhp-cart-close]');
          focusTarget?.focus({preventScroll:true});
        }
      }
    };
    rhpCartDrawer.addEventListener('click',async event=>{
      if(event.target.closest('[data-rhp-cart-close]')){rhpCloseCart();return;}
      const remove=event.target.closest('[data-rhp-cart-remove]');
      const qtyButton=event.target.closest('[data-rhp-qty-minus],[data-rhp-qty-plus]');
      const crossAdd=event.target.closest('[data-rhp-cross-sell-add]');
      if(crossAdd){
        if(crossAdd.disabled||rhpCartMutationBusy)return;
        const variantId=Number(rhpCartCrossSell?.dataset.rhpVariantId||0); if(!variantId)return;
        const status=rhpCartCrossSell?.querySelector('[data-rhp-cross-sell-status]');
        if(status)status.textContent='';
        rhpCartMutationBusy=true;
        crossAdd.disabled=true;crossAdd.setAttribute('aria-busy','true');
        let errorMessage=rhpIsSpanish?'No se pudo confirmar. Revisa tu carrito antes de volver a intentarlo.':'Could not confirm the addition. Check your cart before trying again.';
        try{
          const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
          if(!response.ok){
            if(response.status>=400&&response.status<500)errorMessage=rhpIsSpanish?'No se pudo añadir este artículo. Revisa tu selección e inténtalo de nuevo.':'This item could not be added. Please review your selection and try again.';
            throw new Error('Cart add failed');
          }
          errorMessage=rhpIsSpanish?'Artículo añadido. Abre tu carrito para revisarlo.':'This item was added. Open your cart to review it.';
          try{await rhpRefreshCart();}catch{window.location.assign('/cart');}
        }
        catch(error){if(status)status.textContent=errorMessage;}
        finally{rhpCartMutationBusy=false;crossAdd.disabled=false;crossAdd.removeAttribute('aria-busy');}
        return;
      }
      if(remove){
        if(remove.disabled||rhpCartMutationBusy)return;
        await rhpChangeDrawerCart(remove.dataset.rhpCartRemove,0,remove);
        return;
      }
      if(qtyButton){
        if(qtyButton.disabled||rhpCartMutationBusy)return;
        const key=qtyButton.dataset.rhpKey;
        const input=rhpCartDrawer.querySelector(`[data-rhp-qty-input][data-rhp-key="${CSS.escape(key)}"]`);
        const current=Math.max(1,Math.floor(Number(input?.value)||1));
        await rhpChangeDrawerCart(key,qtyButton.hasAttribute('data-rhp-qty-plus')?current+1:current-1,qtyButton);
      }
    });
    rhpCartDrawer.addEventListener('change',async event=>{
      const input=event.target.closest('[data-rhp-qty-input]');
      if(!input||input.disabled||rhpCartMutationBusy)return;
      const value=Number(input.value);
      if(!Number.isSafeInteger(value)||value<1){input.value=input.defaultValue;return;}
      await rhpChangeDrawerCart(input.dataset.rhpKey,value,input);
    });
    // Keep keyboard navigation inside the open cart panel.
    document.addEventListener('keydown',event=>{
      if(!rhpCartDrawer.classList.contains('is-open'))return;
      if(event.key==='Escape'){event.preventDefault();rhpCloseCart();return}
      if(event.key!=='Tab'||!rhpCartPanel)return;
      const available=[...rhpCartPanel.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter(node=>!node.disabled&&node.tabIndex>=0&&node.getClientRects().length&&getComputedStyle(node).visibility!=='hidden');
      const first=available[0],last=available.at(-1);
      if(!first)return;
      const active=document.activeElement;
      if(!available.includes(active)){event.preventDefault();(event.shiftKey?last:first).focus()}
      else if(event.shiftKey&&active===first){event.preventDefault();last.focus()}
      else if(!event.shiftKey&&active===last){event.preventDefault();first.focus()}
    });
    if(document.querySelector('[data-rhp-cart-page]'))rhpRefreshCart().catch(()=>{});
  }
  const rhpCartPage=document.querySelector('[data-rhp-cart-page]');
  if(rhpCartPage){
    let rhpPageBusy=false;
    const rhpPageStatus=document.createElement('p');
    rhpPageStatus.setAttribute('role','alert');
    rhpPageStatus.hidden=true;
    rhpCartPage.prepend(rhpPageStatus);
    const rhpPageMessage=message=>{rhpPageStatus.textContent=message;rhpPageStatus.hidden=!message;};
    const rhpPageSpanish=document.documentElement.lang.toLowerCase().startsWith('es');
    const rhpPageChange=async(key,quantity,control)=>{
      if(!key||rhpPageBusy||!Number.isSafeInteger(quantity)||quantity<0)return;
      rhpPageMessage('');
      rhpPageBusy=true;
      rhpCartPage.classList.add('is-updating');
      if(control)control.disabled=true;
      try{
        const response=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});
        if(!response.ok)throw new Error('Cart update failed');
        window.location.reload();
      }catch(error){
        rhpCartPage.classList.remove('is-updating');
        if(control){control.disabled=false;if(control.matches('[data-rhp-page-qty-input]'))control.value=control.defaultValue;}
        rhpPageMessage(rhpPageSpanish?'No se pudo confirmar el cambio. Actualiza el carrito antes de volver a intentarlo.':'Could not confirm the update. Refresh your cart before trying again.');
      }finally{rhpPageBusy=false;}
    };
    rhpCartPage.addEventListener('submit',event=>{
      if(!rhpPageBusy)return;
      event.preventDefault();
      rhpPageMessage(rhpPageSpanish?'El carrito se está actualizando. Espera un momento.':'Your cart is updating. Please wait a moment.');
    });
    rhpCartPage.addEventListener('click',event=>{
      const button=event.target.closest('[data-rhp-page-qty-minus],[data-rhp-page-qty-plus],[data-rhp-page-remove]');
      if(!button||button.disabled||rhpPageBusy)return;
      event.preventDefault();
      const key=button.dataset.rhpPageKey||button.dataset.rhpPageRemove;
      const input=rhpCartPage.querySelector(`[data-rhp-page-qty-input][data-rhp-page-key="${CSS.escape(key)}"]`);
      const entered=Number(input?.value);
      const current=Number.isSafeInteger(entered)&&entered>=1?entered:Math.max(1,Math.floor(Number(input?.defaultValue)||1));
      const quantity=button.hasAttribute('data-rhp-page-qty-plus')?current+1:button.hasAttribute('data-rhp-page-qty-minus')?Math.max(0,current-1):0;
      rhpPageChange(key,quantity,button);
    });
    rhpCartPage.addEventListener('change',event=>{
      const input=event.target.closest('[data-rhp-page-qty-input]');
      if(!input)return;
      if(input.disabled||rhpPageBusy){input.value=input.defaultValue;return;}
      const quantity=Number(input.value);
      if(!Number.isSafeInteger(quantity)||quantity<1){
        input.value=input.defaultValue;
        rhpPageMessage(rhpPageSpanish?'Introduce una cantidad entera de 1 o más.':'Enter a whole-number quantity of 1 or more.');
        return;
      }
      rhpPageChange(input.dataset.rhpPageKey,quantity,input);
    });
  }
  document.querySelectorAll('[data-catalog-product]').forEach(product=>{
    const gallery=product.querySelector('[data-catalog-gallery]');
    let main=gallery?.querySelector('[data-catalog-main-image]');
    const frame=gallery?.querySelector('.catalog-product-main-image');
    const thumbs=Array.from(gallery?.querySelectorAll('[data-catalog-thumb]')||[]);
    const count=gallery?.querySelector('[data-catalog-count]');
    let current=Math.max(0,thumbs.findIndex(thumb=>thumb.classList.contains('is-active')));
    let mobileTrack;
    let closeInlineZoom=()=>{};
    let galleryGeneration=0;
    let cancelDesktopTransition=()=>{};
    const mobileGallery=()=>Boolean(mobileTrack&&window.matchMedia('(max-width:759px)').matches);
    const setGallerySource=(image,thumb)=>{
      if(thumb.dataset.imageSrcset){
        image.sizes='(max-width: 700px) calc(100vw - 32px), (max-width: 1023px) calc(50vw - 40px), 50vw';
        image.srcset=thumb.dataset.imageSrcset;
      }else{
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }
      image.src=thumb.dataset.imageSrc;
    };
    const hydrateMobileImage=image=>{
      if(!image||image.dataset.catalogImageHydrated==='true')return;
      const thumb=thumbs[Number(image.dataset.catalogImageIndex)];
      if(!thumb)return;
      setGallerySource(image,thumb);
      image.dataset.catalogImageHydrated='true';
    };
    const hydrateMobileImages=index=>{
      if(!mobileTrack)return;
      const normalized=(index+thumbs.length)%thumbs.length;
      const wanted=new Set([
        normalized,
        (normalized-1+thumbs.length)%thumbs.length,
        (normalized+1)%thumbs.length
      ]);
      mobileTrack.querySelectorAll('img[data-catalog-image-index]').forEach(image=>{
        if(wanted.has(Number(image.dataset.catalogImageIndex)))hydrateMobileImage(image);
      });
    };
    const syncMobileImage=index=>{
      cancelDesktopTransition();
      current=(index+thumbs.length)%thumbs.length;
      const selected=thumbs[current];
      setGallerySource(main,selected);
      hydrateMobileImages(current);
      main.alt=selected.dataset.imageAlt||main.alt;
      main.classList.toggle('catalog-gallery-detail',current===5);
      thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===current);thumb.setAttribute('aria-current',i===current?'true':'false')});
      if(count)count.textContent=`${current+1} / ${thumbs.length}`;
    };
    if(["red-bull-extreme-honey","loriz-premium-shilajit-honey","premium-honey-sachets-individually-packed","php-royal-honey-supplement"].includes(product.dataset.productHandle)&&frame&&main&&thumbs.length>1){
      mobileTrack=document.createElement('div');
      mobileTrack.className='catalog-mobile-track';
      mobileTrack.setAttribute('aria-label','Product images');
      thumbs.forEach((thumb,index)=>{
        const image=document.createElement('img');
        image.dataset.catalogImageIndex=String(index);image.alt=thumb.dataset.imageAlt||main.alt;
        image.width=1254;image.height=1254;image.loading=index===current?'eager':'lazy';image.decoding='async';
        if(index===5)image.classList.add('catalog-gallery-detail');
        mobileTrack.append(image);
      });
      const before=mobileTrack.lastElementChild.cloneNode(true),after=mobileTrack.firstElementChild.cloneNode(true);
      [before,after].forEach(image=>{image.alt='';image.setAttribute('aria-hidden','true');image.loading='lazy'});
      mobileTrack.prepend(before);mobileTrack.append(after);
      frame.prepend(mobileTrack);
      hydrateMobileImages(current);
      let settleTimer;
      let touchingTrack=false;
      const hydrateNearScrollPosition=()=>{
        const step=mobileTrack.children[1].offsetLeft-mobileTrack.children[0].offsetLeft;
        if(step>0)hydrateMobileImages(Math.round(mobileTrack.scrollLeft/step)-1);
      };
      const settle=()=>{
        if(!mobileGallery()||touchingTrack)return;
        window.clearTimeout(settleTimer);
        const step=mobileTrack.children[1].offsetLeft-mobileTrack.children[0].offsetLeft;
        if(step>0){
          const position=Math.max(0,Math.min(thumbs.length+1,Math.round(mobileTrack.scrollLeft/step)));
          syncMobileImage(position-1);
          const target=mobileTrack.children[current+1].offsetLeft-mobileTrack.children[0].offsetLeft;
          if(Math.abs(mobileTrack.scrollLeft-target)>1)mobileTrack.scrollTo({left:target,behavior:'instant'});
        }
      };
      const scheduleSettlement=()=>{
        window.clearTimeout(settleTimer);
        // Some mobile browsers expose scrollend but omit it after interrupted gestures.
        if(!touchingTrack)settleTimer=window.setTimeout(settle,220);
      };
      mobileTrack.addEventListener('touchstart',()=>{touchingTrack=true;window.clearTimeout(settleTimer)},{passive:true});
      const releaseTrack=event=>{touchingTrack=Boolean(event.touches?.length);scheduleSettlement()};
      mobileTrack.addEventListener('touchend',releaseTrack,{passive:true});
      mobileTrack.addEventListener('touchcancel',releaseTrack,{passive:true});
      mobileTrack.addEventListener('scroll',()=>{hydrateNearScrollPosition();scheduleSettlement()},{passive:true});
      mobileTrack.addEventListener('scrollend',settle);
      const align=()=>{if(mobileGallery())mobileTrack.scrollTo({left:mobileTrack.children[current+1].offsetLeft-mobileTrack.children[0].offsetLeft,behavior:'instant'})};
      new ResizeObserver(align).observe(mobileTrack);
    }
    const galleryDiscount=frame?.querySelector('[data-catalog-discount]');
    if(galleryDiscount){
      const positionDiscount=()=>{
        if(!mobileGallery()){
          galleryDiscount.style.transform='';
          galleryDiscount.style.visibility=current===0?'':'hidden';
          return;
        }
        const bounds=frame.getBoundingClientRect();
        // The final clone is also photo one, used when wrapping the native track.
        const candidates=[mobileTrack.children[1],mobileTrack.lastElementChild];
        const first=candidates.map(image=>image.getBoundingClientRect()).sort((a,b)=>Math.abs(a.left-bounds.left)-Math.abs(b.left-bounds.left))[0];
        const offset=first.right-bounds.right;
        galleryDiscount.style.transform=`translateX(${offset}px)`;
        galleryDiscount.style.visibility=first.right-8<=bounds.left||first.right-8-galleryDiscount.offsetWidth>=bounds.right?'hidden':'';
      };
      mobileTrack?.addEventListener('scroll',positionDiscount,{passive:true});
      new ResizeObserver(positionDiscount).observe(frame);
      const discountObserver=new MutationObserver(positionDiscount);
      thumbs.forEach(thumb=>discountObserver.observe(thumb,{attributes:true,attributeFilter:['aria-current']}));
      discountObserver.observe(galleryDiscount,{attributes:true,attributeFilter:['hidden']});
      positionDiscount();
    }
    if(["red-bull-extreme-honey","loriz-premium-shilajit-honey","premium-honey-sachets-individually-packed","php-royal-honey-supplement"].includes(product.dataset.productHandle)&&frame&&document.querySelector('[data-review-lightbox-modal]')){
      const zoom=document.createElement('button');
      zoom.type='button';zoom.className='catalog-gallery-zoom';zoom.setAttribute('data-catalog-zoom','');
      zoom.setAttribute('aria-label',document.documentElement.lang.toLowerCase().startsWith('es')?'Haz clic para ampliar':'Click to zoom');
      zoom.innerHTML='<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M10 7v6M7 10h6"/></svg>';
      frame.append(zoom);
      closeInlineZoom=rhpInitInlineGalleryZoom(frame,zoom,()=>{
        syncMobileImage(current);
        return {src:thumbs[current]?.dataset.imageSrc||main.src,alt:thumbs[current]?.dataset.imageAlt||main.alt};
      });
    }
    let pointerStart;
    let transitionTimer;
    let isGalleryTransitioning=false;
    let queuedGalleryTransitions=[];
    cancelDesktopTransition=()=>{
      if(!isGalleryTransitioning)return;
      galleryGeneration++;
      window.clearTimeout(transitionTimer);
      queuedGalleryTransitions=[];
      frame.querySelectorAll('.catalog-gallery-incoming').forEach(image=>image.remove());
      main.classList.remove('is-slide-out-next','is-slide-out-prev');
      isGalleryTransitioning=false;
    };
    const imageCache=new Map();
    const cacheImage=(source,thumb)=>{
      if(imageCache.has(source))return imageCache.get(source);
      const image=new Image();
      image.decoding='async';
      setGallerySource(image,thumb);
      const ready=image.decode?image.decode().then(()=>true,()=>false):new Promise(resolve=>{
        image.addEventListener('load',()=>resolve(true),{once:true});
        image.addEventListener('error',()=>resolve(false),{once:true});
      });
      const entry={image,ready:ready.then(loaded=>{
        if(!loaded&&imageCache.get(source)===entry)imageCache.delete(source);
        return loaded;
      })};
      imageCache.set(source,entry);
      return entry;
    };
    const warmImage=index=>{
      const thumb=thumbs[(index+thumbs.length)%thumbs.length];
      if(!thumb)return;
      thumb.dataset.imageWarmed='true';
      return cacheImage(new URL(thumb.dataset.imageSrc,window.location.href).href,thumb);
    };
    const completeGalleryTransition=()=>{
      isGalleryTransitioning=false;
      let queued;
      while((queued=queuedGalleryTransitions.shift())){
        if(queued.index!==current){showImage(queued.index,queued.direction);break;}
      }
    };
    const showImage=(index,direction)=>{
      if(!main||!thumbs.length)return;
      closeInlineZoom(false);
      if(mobileGallery()){
        const next=(index+thumbs.length)%thumbs.length;
        const position=current===thumbs.length-1&&next===0&&direction>0?thumbs.length+1:current===0&&next===thumbs.length-1&&direction<0?0:next+1;
        syncMobileImage(next);
        mobileTrack.scrollTo({left:mobileTrack.children[position].offsetLeft-mobileTrack.children[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        return;
      }
      const previous=current;
      const nextIndex=(index+thumbs.length)%thumbs.length;
      const moveDirection=direction||(index===previous?0:(index>previous?1:-1));
      if(nextIndex===previous)return;
      if(isGalleryTransitioning){
        queuedGalleryTransitions.push({index:nextIndex,direction:moveDirection});
        return;
      }
      current=nextIndex;
      const selected=thumbs[current];
      isGalleryTransitioning=true;
      thumbs.forEach((thumb,thumbIndex)=>{
        const active=thumbIndex===current;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-current',active?'true':'false');
      });
      if(count)count.textContent=`${current+1} / ${thumbs.length}`;
      // Reveal an offscreen thumbnail within its own strip, without scrolling the page.
      const strip=selected.closest('.catalog-product-thumbs');
      if(strip){
        const bounds=strip.getBoundingClientRect(),item=selected.getBoundingClientRect();
        const left=bounds.left+strip.clientLeft,top=bounds.top+strip.clientTop;
        const dx=strip.scrollWidth>strip.clientWidth+1?(item.left<left?item.left-left:Math.max(0,item.right-left-strip.clientWidth)):0;
        const dy=strip.scrollHeight>strip.clientHeight+1?(item.top<top?item.top-top:Math.max(0,item.bottom-top-strip.clientHeight)):0;
        if(dx||dy)strip.scrollTo({left:strip.scrollLeft+dx,top:strip.scrollTop+dy,behavior:'auto'});
      }
      const nextSrc=new URL(selected.dataset.imageSrc,window.location.href).href;
      if(main.src===nextSrc){
        completeGalleryTransition();
        return;
      }
      const cached=cacheImage(nextSrc,selected);
      const generation=galleryGeneration;
      cached.ready.then(loaded=>{
        if(generation!==galleryGeneration)return;
        if(!loaded){
          current=previous;
          thumbs.forEach((thumb,thumbIndex)=>{
            const active=thumbIndex===current;
            thumb.classList.toggle('is-active',active);
            thumb.setAttribute('aria-current',active?'true':'false');
          });
          if(count)count.textContent=`${current+1} / ${thumbs.length}`;
          completeGalleryTransition();
          return;
        }
        if(!moveDirection){
          setGallerySource(main,selected);
          main.alt=selected.dataset.imageAlt||main.alt;
          main.classList.toggle('catalog-gallery-detail',current===5);
          warmImage(current+1);
          completeGalleryTransition();
          return;
        }
        const outgoing=main;
        const incoming=cached.image;
        incoming.className=`catalog-gallery-incoming ${moveDirection>0?'is-slide-in-next':'is-slide-in-prev'}`;
        if(current===5)incoming.classList.add('catalog-gallery-detail');
        incoming.alt=selected.dataset.imageAlt||main.alt;
        incoming.width=main.width||1254;
        incoming.height=main.height||1254;
        frame.append(incoming);
        main.classList.add(moveDirection>0?'is-slide-out-next':'is-slide-out-prev');
        const finish=()=>{
          if(generation!==galleryGeneration)return;
          if(!incoming.isConnected)return;
          window.clearTimeout(transitionTimer);
          outgoing.remove();
          incoming.className=current===5?'catalog-gallery-detail':'';
          incoming.setAttribute('data-catalog-main-image','');
          main=incoming;
          warmImage(current+1);
          completeGalleryTransition();
        };
        incoming.addEventListener('transitionend',event=>{
          if(event.propertyName!=='transform')return;
          finish();
        },{once:true});
        transitionTimer=window.setTimeout(finish,520);
        requestAnimationFrame(()=>requestAnimationFrame(()=>incoming.classList.add('is-sliding')));
      });
    };
    thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>showImage(index,index===current?0:(index>current?1:-1))));
    const queuedIndex=()=>queuedGalleryTransitions.length?queuedGalleryTransitions[queuedGalleryTransitions.length-1].index:current;
    gallery?.querySelector('[data-catalog-prev]')?.addEventListener('click',()=>showImage(queuedIndex()-1,-1));
    gallery?.querySelector('[data-catalog-next]')?.addEventListener('click',()=>showImage(queuedIndex()+1,1));
    frame?.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();showImage(queuedIndex()-1,-1)}
      if(event.key==='ArrowRight'){event.preventDefault();showImage(queuedIndex()+1,1)}
    });
    frame?.addEventListener('pointerdown',event=>{if(!mobileGallery()&&!event.target.closest('button')&&event.isPrimary!==false&&(event.button===undefined||event.button===0))pointerStart={x:event.clientX,y:event.clientY,id:event.pointerId}});
    frame?.addEventListener('pointerup',event=>{if(!pointerStart||event.pointerId!==pointerStart.id)return;const distance=event.clientX-pointerStart.x,vertical=event.clientY-pointerStart.y;pointerStart=undefined;if(Math.abs(distance)>45&&Math.abs(distance)>Math.abs(vertical)*1.25)showImage(queuedIndex()+(distance<0?1:-1),distance<0?1:-1)});
    frame?.addEventListener('pointercancel',()=>{pointerStart=undefined});
    warmImage(current+1);
    const form=product.querySelector('[data-catalog-form]')||product.querySelector('form');
    const variants=Array.from(product.querySelectorAll('[data-catalog-variant]'));
    const purchaseOptions=Array.from(product.querySelectorAll('[data-catalog-purchase]'));
    const subscribeToggle=product.querySelector('[data-catalog-subscribe-toggle]');
    const sellingPlan=product.querySelector('[data-catalog-selling-plan]');
    const price=product.querySelector('[data-catalog-price]');
    const currentPrice=product.querySelector('[data-catalog-current]');
    const comparePrice=product.querySelector('[data-catalog-compare]');
    const priceCaption=product.querySelector('[data-catalog-price-caption]');
    const oneTimePrice=product.querySelector('[data-catalog-one-time-price]');
    const subscriptionPrice=product.querySelector('[data-catalog-subscription-price]');
    const subscriptionCompare=product.querySelector('[data-catalog-subscription-compare]');
    const addButton=product.querySelector('[data-catalog-add]');
    const addon=document.querySelector('[data-catalog-addon]');
    const addonToggle=addon?.querySelector('[data-catalog-addon-toggle]');
    const prompt=document.querySelector('[data-catalog-subscription-prompt]');
    const labels=product.dataset;
    let pendingAddMode='one-time';
    let restoringFocus;
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang.startsWith('es')?'es-MX':'en-US',{style:'currency',currency:'USD'}).format(Number(cents||0)/100);
    const escapeHtml=value=>String(value||'').replace(/[&<>'"]/g,character=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
  let previousVariantId='';
  const selectedVariant=()=>variants.find(item=>item.checked);
  const selectedPurchase=()=>purchaseOptions.find(item=>item.checked)?.value||(subscribeToggle?.checked?'subscription':'one-time');
  const defaultBundleVariant=/honey/i.test(String(product.dataset.productHandle||''))?variants.find(item=>{const title=String(item.dataset.variantTitle||'').toLowerCase();return /buy\s*2/.test(title)&&/(?:get\s*1|1\s*free)/.test(title)}):undefined;
  if(defaultBundleVariant){
    defaultBundleVariant.checked=true;
    const subscriptionOption=purchaseOptions.find(item=>item.value==='subscription');
    if(subscriptionOption)subscriptionOption.checked=true;
    else if(subscribeToggle)subscribeToggle.checked=true;
  }
  form?.addEventListener('formdata',event=>{
    const plan=selectedPurchase()==='subscription'?selectedVariant()?.dataset.sellingPlanId:'';
    if(plan)event.formData.set('selling_plan',plan);else event.formData.delete('selling_plan');
  });
  let sellingPlanSyncToken=0;
  const setSellingPlan=value=>{
    const next=String(value||'');
    const token=++sellingPlanSyncToken;
    const apply=()=>{
      if(token!==sellingPlanSyncToken)return;
      document.querySelectorAll('[data-catalog-selling-plan]').forEach(input=>{
        input.value=next;
        input.defaultValue=next;
        input.setAttribute('value',next);
      });
    };
    apply();
    [0,50,250,800].forEach(delay=>window.setTimeout(apply,delay));
  };
    const setLayer=(layer,open,focusTarget)=>{
      if(!layer)return;
      if(open){
        restoringFocus=document.activeElement;
        layer.hidden=false;
        layer.setAttribute('aria-hidden','false');
        requestAnimationFrame(()=>layer.classList.add('is-open'));
        document.body.classList.add('catalog-overlay-open');
        window.setTimeout(()=>focusTarget?.focus(),30);
      }else{
        layer.classList.remove('is-open');
        layer.setAttribute('aria-hidden','true');
        window.setTimeout(()=>{layer.hidden=true},180);
        if(!document.querySelector('.catalog-cart-drawer.is-open,.catalog-subscription-prompt.is-open'))document.body.classList.remove('catalog-overlay-open');
        restoringFocus?.focus?.();
      }
    };
    const updateProduct=(updateUrl=false)=>{
      const variant=selectedVariant();
      if(!variant)return;
      const variantChanged=Boolean(previousVariantId&&previousVariantId!==variant.value);
      const frequency=product.querySelector('[data-subscription-frequency]');
      const allocationData=product.querySelector('[data-subscription-allocations]');
      if(frequency&&allocationData){
        const allocations=JSON.parse(allocationData.textContent).variants;
        const current=allocations[variant.value]||[];
        const plansForVariant=current.map(plan=>({...plan,id:String(plan.id)}));
        const selectedTitle=String(variant.dataset.variantTitle||'').toLowerCase();
        const isBuyTwo=selectedTitle.includes('buy 2')||selectedTitle.includes('2 get 1');
        const mostPopular=plansForVariant.find(plan=>/4\s*weeks?/i.test(plan.name)||/most popular/i.test(plan.name));
        let frequencyId=String(frequency.value||'');
        if(!plansForVariant.some(plan=>plan.id===frequencyId))frequencyId='';
        if(isBuyTwo&&(!previousVariantId||variantChanged)){const preferred=mostPopular||plansForVariant.find(plan=>/month/i.test(plan.name));if(preferred)frequencyId=preferred.id;}
        if(!frequencyId&&plansForVariant.length)frequencyId=plansForVariant[0].id;
        if(current.length&&(!Array.from(frequency.options).some(option=>option.value===frequencyId)||frequency.options.length!==current.length)){
          frequency.replaceChildren(...plansForVariant.map(plan=>{const option=document.createElement('option');option.value=plan.id;option.textContent=plan.name;return option}));
        }
        if(frequencyId)frequency.value=frequencyId;
        variants.forEach(input=>{
          const plan=(allocations[input.value]||[]).find(item=>String(item.id)===frequency.value);
          input.dataset.sellingPlanId=plan?.id||'';
          input.dataset.subscriptionPrice=plan?money(plan.price):'';
          input.dataset.subscriptionPriceCents=plan?.price||'';
          input.dataset.subscriptionComparePrice=plan?money(plan.regular):'';
          input.dataset.subscriptionComparePriceCents=plan?.regular||'';
        });
        const plan=current.find(item=>String(item.id)===frequency.value);
        const saving=product.querySelector('[data-subscription-saving]');
        if(saving&&plan)saving.textContent=`SAVE ${Math.round((1-plan.price/plan.regular)*100)}%`;
      }
      const selected=selectedVariant();
      if(!selected)return;
      const subscription=selectedPurchase()==='subscription'&&selected.dataset.sellingPlanId;
      variants.forEach(item=>{
        const card=item.closest('[data-catalog-variant-card]');
        if(!card)return;
        card.classList.toggle('is-selected',item===selected);
        const cardPrice=card.querySelector('.catalog-pack-prices b');
        const cardCompare=card.querySelector('.catalog-pack-prices s');
        const perSachet=card.querySelector('[data-catalog-per-sachet]');
        const shippingBadge=card.querySelector('[data-catalog-shipping-badge]');
        const hasSubscriptionPrice=subscription&&item.dataset.subscriptionPrice;
        const savings=card.querySelector('[data-catalog-pack-save]');
        if(savings){
          const base=Number(hasSubscriptionPrice?item.dataset.priceCents:item.dataset.comparePriceCents);
          const current=Number(hasSubscriptionPrice?item.dataset.subscriptionPriceCents:item.dataset.priceCents);
          savings.hidden=!(base>current);
          savings.textContent=base>current?`${labels.saveLabel||'Save'} ${money(base-current)}!`:'';
        }
        if(cardPrice)cardPrice.textContent=hasSubscriptionPrice?item.dataset.subscriptionPrice:item.dataset.price;
        if(perSachet){const sachetCount=Number(item.dataset.sachetCount||0);const cents=Number(hasSubscriptionPrice?item.dataset.subscriptionPriceCents:item.dataset.priceCents||0);perSachet.textContent=sachetCount&&cents?`${money(cents/sachetCount)} / sachet`:'';}
        if(cardCompare){
          const cardComparePrice=hasSubscriptionPrice?item.dataset.price:item.dataset.comparePrice;
          cardCompare.textContent=cardComparePrice||'';
          cardCompare.hidden=!cardComparePrice||cardComparePrice===(hasSubscriptionPrice?item.dataset.subscriptionPrice:item.dataset.price);
        }
        if(shippingBadge){
          shippingBadge.textContent=labels.freeShippingLabel;
        }
      });
      product.querySelectorAll('[data-catalog-purchase-card],.catalog-purchase-option').forEach(card=>{
        const input=card.querySelector('[data-catalog-purchase]');
        if(input)card.classList.toggle('is-selected',input===purchaseOptions.find(item=>item.checked));
      });
      const subscriptionDetails=product.querySelector('.catalog-subscription-details');
      if(subscriptionDetails)subscriptionDetails.setAttribute('aria-hidden',selectedPurchase()==='subscription'?'false':'true');
    setSellingPlan(subscription?selected.dataset.sellingPlanId:'');
      const shownPrice=subscription?selected.dataset.subscriptionPrice:selected.dataset.price;
      const shownCompare=subscription?selected.dataset.subscriptionComparePrice:selected.dataset.comparePrice;
      const galleryDiscount=product.querySelector('[data-catalog-discount]');
      if(galleryDiscount){
        const amount=Number(subscription?selected.dataset.subscriptionPriceCents:selected.dataset.priceCents);
        const comparison=Number(subscription?selected.dataset.subscriptionComparePriceCents:selected.dataset.comparePriceCents);
        const discount=Number.isFinite(amount)&&comparison>amount&&amount>=0?Math.floor((comparison-amount)*100/comparison):0;
        galleryDiscount.hidden=discount<=0;
        galleryDiscount.textContent=`${discount}% ${labels.offLabel||'OFF'}`;
      }
      if(currentPrice)currentPrice.textContent=shownPrice||selected.dataset.price;
      if(comparePrice){
        comparePrice.textContent=shownCompare||'';
        comparePrice.hidden=!shownCompare||shownCompare===shownPrice;
      }
      if(priceCaption)priceCaption.textContent=subscription?labels.subscriptionPriceLabel:labels.oneTimeLabel;
      if(oneTimePrice)oneTimePrice.textContent=selected.dataset.price;
      if(subscriptionPrice)subscriptionPrice.textContent=selected.dataset.subscriptionPrice||selected.dataset.price;
      if(subscriptionCompare){
        subscriptionCompare.textContent=selected.dataset.subscriptionComparePrice||'';
        subscriptionCompare.hidden=!selected.dataset.subscriptionComparePrice;
      }
      const oneTimeOption=product.querySelector('[data-catalog-one-time-price]');
      if(oneTimeOption)oneTimeOption.textContent=selected.dataset.price||'';
      const sticky=product.querySelector('[data-mobile-sticky-atc]');
      if(sticky){const stickyPack=sticky.querySelector('[data-mobile-sticky-pack]');const stickyPrice=sticky.querySelector('[data-mobile-sticky-price]');if(stickyPack)stickyPack.textContent=selected.dataset.variantTitle||selected.value;if(stickyPrice)stickyPrice.textContent=shownPrice||selected.dataset.price;const stickyCompare=sticky.querySelector('[data-sticky-compare]');if(stickyCompare){stickyCompare.textContent=shownCompare||'';stickyCompare.hidden=!shownCompare||shownCompare===shownPrice;}}
      if(addButton){
        const available=selected.dataset.available==='true';
        addButton.disabled=!available||addButton.hasAttribute('aria-busy');
        const addButtonLabel=addButton.querySelector('[data-catalog-add-label]');
        const availableLabel=["red-bull-extreme-honey","loriz-premium-shilajit-honey","premium-honey-sachets-individually-packed","php-royal-honey-supplement"].includes(product.dataset.productHandle)?labels.addLabel:`${labels.addLabel} | ${shownPrice||selected.dataset.price}`;
        if(addButtonLabel)addButtonLabel.textContent=available?availableLabel:labels.soldOutLabel;
        else addButton.textContent=available?availableLabel:labels.soldOutLabel;
      }
      previousVariantId=variant.value;
      if(updateUrl){
        const url=new URL(window.location.href);
        url.searchParams.set('variant',selected.value);
        window.history.replaceState({},'',url);
      }
    };
    const renderCart=cart=>window.rhpCartRender?.(cart);
    const refreshCart=async()=>window.rhpCartRefresh?await window.rhpCartRefresh():null;
    const addToCart=async(mode)=>{
      const selected=selectedVariant();
      if(!selected||selected.dataset.available!=='true'||!addButton||addButton.disabled||addButton.hasAttribute('aria-busy'))return;
      const quantityInput=product.querySelector('[data-sticky-quantity]');
      const stickyStatus=product.querySelector('[data-sticky-status]');
      if(stickyStatus)stickyStatus.textContent='';
      const quantity=Math.min(99,Math.max(1,Math.floor(Number(quantityInput?.value)||1)));
      if(quantityInput)quantityInput.value=String(quantity);
      const item={id:Number(selected.value),quantity};
    if(mode==='subscription'&&selected.dataset.sellingPlanId){item.selling_plan=Number(selected.dataset.sellingPlanId);setSellingPlan(selected.dataset.sellingPlanId)}else setSellingPlan('');
      const items=[item];
      if(addonToggle?.checked&&addon?.dataset.addonVariantId)items.push({id:Number(addon.dataset.addonVariantId),quantity:1});
      addButton.disabled=true;
      addButton.setAttribute('aria-busy','true');
      const spanish=document.documentElement.lang.startsWith('es');
      let errorLabel=spanish?'No se pudo confirmar. Revisa tu carrito antes de volver a intentarlo.':'Could not confirm the addition. Check your cart before trying again.';
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if(!response.ok){
          if(response.status>=400&&response.status<500)errorLabel=spanish?'No se pudo añadir. Revisa tu selección e inténtalo de nuevo.':'Could not add. Review your selection and try again.';
          throw new Error('Cart add failed');
        }
        // The item is already added. A drawer refresh failure must not invite
        // another add, which would duplicate the customer's quantity.
        try{
          await refreshCart();
          if(window.rhpCartOpen)window.rhpCartOpen();
          else window.location.assign('/cart');
        }catch{window.location.assign('/cart');}
      }catch(error){
        const addButtonLabel=addButton.querySelector('[data-catalog-add-label]');
        if(addButtonLabel)addButtonLabel.textContent=errorLabel;
        else addButton.textContent=errorLabel;
        if(stickyStatus)stickyStatus.textContent=errorLabel;
        window.setTimeout(()=>updateProduct(),2000);
      }finally{
        addButton.removeAttribute('aria-busy');
        addButton.disabled=selectedVariant()?.dataset.available!=='true';
      }
    };
    variants.forEach(item=>item.addEventListener('change',()=>updateProduct(true)));
    purchaseOptions.forEach(item=>item.addEventListener('change',updateProduct));
    product.querySelector('[data-subscription-frequency]')?.addEventListener('change',()=>updateProduct());
    subscribeToggle?.addEventListener('change',updateProduct);
    addonToggle?.addEventListener('change',()=>addon?.classList.toggle('is-selected',addonToggle.checked));
    form?.addEventListener('submit',event=>{
      event.preventDefault();
      const mode=selectedPurchase();
      addToCart(mode);
    });
    const stickyAtc=product.querySelector('[data-mobile-sticky-atc]');
    const stickySubmit=stickyAtc?.querySelector('[data-mobile-sticky-submit]');
    if(stickyAtc&&stickySubmit&&addButton){
      const footer=document.querySelector('.site-footer');
      const mobile=window.matchMedia('(max-width:749px)');
      const isRedPilot=["red-bull-extreme-honey","loriz-premium-shilajit-honey","premium-honey-sachets-individually-packed","php-royal-honey-supplement"].includes(product.dataset.productHandle);
      const syncStickyVisibility=()=>{
        const mainRect=addButton.getBoundingClientRect();
        const footerRect=footer?.getBoundingClientRect();
        const show=mainRect.bottom<=0&&(isRedPilot||(mobile.matches&&!(footerRect&&footerRect.top<innerHeight&&footerRect.bottom>0)));
        stickyAtc.hidden=!show;
        stickyAtc.setAttribute('aria-hidden',String(!show));
        document.body.classList.toggle('catalog-mobile-sticky-active',show);
      };
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(syncStickyVisibility,{threshold:0});observer.observe(addButton);if(footer)observer.observe(footer)}
      // Anchor jumps can move the main button from below to above the viewport
      // without changing its intersection state, so also observe scrolling.
      window.addEventListener('scroll',syncStickyVisibility,{passive:true});
      window.addEventListener('resize',syncStickyVisibility);
      syncStickyVisibility();
      const quantityInputs=[...product.querySelectorAll('[data-sticky-quantity]')];
      const quantityInput=quantityInputs[0];
      const quantitySteps=[...product.querySelectorAll('[data-sticky-quantity-step]')];
      const syncStickyState=()=>{
        const busy=addButton.hasAttribute('aria-busy');
        stickySubmit.disabled=addButton.disabled||busy;
        stickySubmit.textContent=busy?'Adding…':addButton.disabled?labels.soldOutLabel:labels.addLabel;
        stickySubmit.setAttribute('aria-busy',String(busy));
        if(quantityInput){
          quantityInputs.forEach(input=>input.disabled=busy);
          const quantity=Number(quantityInput.value)||1;
          quantitySteps.forEach(button=>button.disabled=busy||(Number(button.dataset.stickyQuantityStep)<0?quantity<=1:quantity>=99));
        }
      };
      const normalizeQuantity=(source=quantityInput)=>{
        const value=String(Math.min(99,Math.max(1,Math.floor(Number(source.value)||1))));
        quantityInputs.forEach(input=>input.value=value);
        syncStickyState();
      };
      quantityInputs.forEach(input=>{
        input.addEventListener('input',()=>{
          quantityInputs.forEach(peer=>{if(peer!==input)peer.value=input.value});
          syncStickyState();
        });
        input.addEventListener('change',()=>normalizeQuantity(input));
      });
      quantitySteps.forEach(button=>button.addEventListener('click',()=>{quantityInput.value=String((Number(quantityInput.value)||1)+Number(button.dataset.stickyQuantityStep));normalizeQuantity()}));
      new MutationObserver(syncStickyState).observe(addButton,{attributes:true,attributeFilter:['disabled','aria-busy']});
      syncStickyState();
      stickySubmit.addEventListener('click',()=>{if(addButton.disabled)return;if(typeof form?.requestSubmit==='function')form.requestSubmit(addButton);else addButton.click();});
    }
    prompt?.querySelector('[data-catalog-prompt-close]')?.addEventListener('click',()=>setLayer(prompt,false));
    prompt?.querySelectorAll('[data-catalog-prompt-close]').forEach(button=>button.addEventListener('click',()=>setLayer(prompt,false)));
    prompt?.querySelector('[data-catalog-prompt-subscribe]')?.addEventListener('click',()=>{
      if(subscribeToggle){subscribeToggle.checked=true;updateProduct();}
      setLayer(prompt,false);
      addToCart('subscription');
    });
    prompt?.querySelector('[data-catalog-prompt-once]')?.addEventListener('click',()=>{setLayer(prompt,false);addToCart(pendingAddMode)});
    document.addEventListener('keydown',event=>{
      if(event.key!=='Escape')return;
      if(prompt?.classList.contains('is-open'))setLayer(prompt,false);
    });
    updateProduct(Boolean(defaultBundleVariant));
  });
  const main=document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(btn=>btn.addEventListener('click',()=>{if(main&&main.src!==btn.dataset.imageSrc){main.classList.add('is-changing');window.setTimeout(()=>{main.src=btn.dataset.imageSrc;main.addEventListener('load',()=>main.classList.remove('is-changing'),{once:true})},180)}document.querySelectorAll('[data-gallery-thumb]').forEach(item=>item.classList.remove('is-active'));btn.classList.add('is-active')}));
  const galleryThumbs=document.querySelector('.gallery-thumbs');
  if(galleryThumbs){const galleryStep=()=>{const thumb=galleryThumbs.querySelector('.gallery-thumb');return(thumb?.getBoundingClientRect().width||86)+10};document.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>galleryThumbs.scrollBy({left:-galleryStep(),behavior:'smooth'}));document.querySelector('[data-gallery-next]')?.addEventListener('click',()=>galleryThumbs.scrollBy({left:galleryStep(),behavior:'smooth'}))}
  document.querySelectorAll('[data-bundles] .bundle-option').forEach(btn=>btn.addEventListener('click',()=>{
    document.querySelectorAll('[data-bundles] .bundle-option').forEach(item=>item.classList.remove('is-selected'));
    btn.classList.add('is-selected');
    const subscriptionPrice=document.querySelector('.subscription-prices [data-subscription-price]');
    const subscriptionOriginal=document.querySelector('.subscription-prices [data-subscription-original]');
    if(subscriptionPrice)subscriptionPrice.textContent=btn.dataset.subscriptionPrice;
    if(subscriptionOriginal)subscriptionOriginal.textContent=btn.dataset.subscriptionOriginal;
  }));
  const toggle=document.querySelector('[data-menu-toggle]');const nav=document.querySelector('[data-mobile-nav]');if(toggle&&nav)toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',open?'true':'false');document.body.classList.toggle('menu-open',open)});
  const kitsch=document.querySelector('[data-kitsch-bundles]')?document:null;
  if(kitsch){
    const showAddedCart=async()=>{
      try{if(typeof window.rhpCartRefresh!=='function'||typeof window.rhpCartOpen!=='function'){window.location.assign('/cart');return}await window.rhpCartRefresh();await window.rhpCartOpen();}
      catch(error){window.location.assign('/cart');}
    };
    const bundleCurrency=kitsch.querySelector('[data-bundle-mode="fbt"]')?.dataset.bundleCurrency||window.Shopify?.currency?.active||'USD';
    const moneyKitsch=cents=>new Intl.NumberFormat(document.documentElement.lang.startsWith('es')?'es-MX':'en-US',{style:'currency',currency:bundleCurrency}).format(Number(cents||0)/100);
    const items=[...kitsch.querySelectorAll('[data-kitsch-item]')], total=kitsch.querySelector('[data-kitsch-total]');
    const bundleItemSelected=item=>{const check=item.querySelector('[data-kitsch-check]');return check?.checked&&!check.disabled};
    const syncKitschTotal=()=>{
      const selected=items.filter(bundleItemSelected);
      if(total)total.textContent=moneyKitsch(selected.reduce((sum,i)=>sum+Number(i.dataset.priceCents||0),0));
      const handles=new Set(selected.map(item=>item.dataset.bundleItemHandle));
      let visibleCount=0;
      kitsch.querySelectorAll('[data-bundle-image-handle]').forEach(image=>{
        const visible=handles.has(image.dataset.bundleImageHandle);
        image.hidden=!visible;
        const separator=image.previousElementSibling;
        if(separator?.matches('[data-bundle-image-separator]'))separator.hidden=!visible||visibleCount===0;
        if(visible)visibleCount++;
      });
      const images=kitsch.querySelector('.kitsch-fbt-images'),footer=kitsch.querySelector('.kitsch-fbt-footer');
      if(images)images.hidden=selected.length===0;
      if(footer)footer.hidden=selected.length===0;
      const status=kitsch.querySelector('[data-kitsch-status]');
      if(status)status.textContent='';
    };
    const bundleProduct=document.querySelector('[data-catalog-product]:is([data-product-handle="red-bull-extreme-honey"],:is([data-product-handle="loriz-premium-shilajit-honey"],[data-product-handle="premium-honey-sachets-individually-packed"],[data-product-handle="php-royal-honey-supplement"]))');
    const primaryBundleItem=items.find(item=>item.dataset.bundleItemHandle===bundleProduct?.dataset.productHandle);
    const syncBundleVariant=()=>{
      if(!bundleProduct||!primaryBundleItem)return;
      const variant=bundleProduct.querySelector('[data-catalog-variant]:checked');
      if(!variant)return;
      primaryBundleItem.dataset.variantId=variant.value;
      const bundleLinks=[primaryBundleItem.querySelector('.kitsch-fbt-copy a'),kitsch.querySelector(`[data-bundle-image-handle="${bundleProduct?.dataset.productHandle}"]`)];
      bundleLinks.forEach(link=>{if(!link)return;const url=new URL(link.href,window.location.origin);url.searchParams.set('variant',variant.value);link.href=url.pathname+url.search+url.hash;});
      primaryBundleItem.dataset.priceCents=variant.dataset.priceCents;
      const available=variant.dataset.available==='true';
      primaryBundleItem.querySelector('[data-kitsch-check]').disabled=!available;
      const price=primaryBundleItem.querySelector('.kitsch-fbt-copy strong');
      if(price)price.textContent=moneyKitsch(variant.dataset.priceCents);
      const label=primaryBundleItem.querySelector('[data-bundle-variant-label]');
      if(label)label.textContent=`${variant.dataset.variantTitle||''} · ${available?'One-time purchase':'Sold out'}`;
      syncKitschTotal();
    };
    bundleProduct?.addEventListener('change',event=>{if(event.target.matches('[data-catalog-variant]'))syncBundleVariant()});
    syncBundleVariant();
    items.forEach(i=>i.querySelector('[data-kitsch-check]')?.addEventListener('change',syncKitschTotal)); syncKitschTotal();
    kitsch.querySelector('[data-kitsch-add]')?.addEventListener('click',async event=>{
      const button=event.currentTarget,status=kitsch.querySelector('[data-kitsch-status]');
      if(button.disabled)return;
      const selected=items.filter(bundleItemSelected).map(i=>({id:Number(i.dataset.variantId),quantity:1}));
      if(!selected.length){if(status)status.textContent='Select at least one product.';return}
      button.disabled=true;button.setAttribute('aria-busy','true');
      if(status)status.textContent='';
      let feedback='Could not confirm the addition. Check your cart before trying again.';
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:selected})});
        if(!response.ok){
          if(response.status>=400&&response.status<500)feedback='Could not add selected products. Please review your selection and try again.';
          throw new Error('Cart add failed');
        }
        feedback='Products were added. Open your cart to review them.';
        await showAddedCart();
        if(status)status.textContent='Added to cart.';
      }catch(error){if(status)status.textContent=feedback}
      finally{button.disabled=false;button.removeAttribute('aria-busy')}
    });
    const track=kitsch.querySelector('[data-kitsch-track]');
    if(track&&['red-bull-extreme-honey','loriz-premium-shilajit-honey','premium-honey-sachets-individually-packed','php-royal-honey-supplement'].includes(track.closest('[data-bundle-product]')?.dataset.bundleProduct)){
  const cards=()=>[...kitsch.querySelectorAll('[data-kitsch-addition]')];
  const originalCards=cards(),prev=kitsch.querySelector('[data-kitsch-prev]'),next=kitsch.querySelector('[data-kitsch-next]');
  let settleTimer,moving=false,adjusting=false;
  const stride=()=>{const c=cards();return c[1]?c[1].getBoundingClientRect().left-c[0].getBoundingClientRect().left:0};
  const canLoop=()=>originalCards.length>1&&track.scrollWidth-track.clientWidth>2;
  const rotate=()=>{
    if(adjusting||!canLoop()||track.contains(document.activeElement))return;
    const distance=stride();if(distance<=0)return;
    const index=Math.round(track.scrollLeft/distance);
    if(index===1)return;
    const offset=track.scrollLeft+(1-index)*distance,active=document.activeElement;
    adjusting=true;track.style.scrollSnapType='none';
    // Move existing cards so the visible card always has a neighbor on each side.
    // Keeping the actual nodes preserves selections and cart feedback without duplicate IDs.
    if(index<1)track.prepend(track.lastElementChild);
    else for(let i=1;i<index;i++)track.append(track.firstElementChild);
    track.scrollLeft=offset;
    if(active&&track.contains(active)&&document.activeElement!==active)active.focus({preventScroll:true});
    window.requestAnimationFrame(()=>{track.style.scrollSnapType='';adjusting=false});
  };
  const settle=()=>{window.clearTimeout(settleTimer);moving=false;rotate()};
  const sync=()=>{
    window.clearTimeout(settleTimer);moving=false;
    const enabled=canLoop();if(prev)prev.disabled=!enabled;if(next)next.disabled=!enabled;
    if(enabled)rotate();
    else if(!track.contains(document.activeElement)){
      const active=document.activeElement;
      originalCards.forEach(card=>track.append(card));track.scrollLeft=0;
      if(active&&track.contains(active)&&document.activeElement!==active)active.focus({preventScroll:true});
    }
  };
  const move=dir=>{
    if(!canLoop()||moving||adjusting)return;
    const distance=stride();if(distance<=0)return;
    moving=true;
    const max=track.scrollWidth-track.clientWidth;
    // With only one more card than fits, there is no spare neighbor after
    // normalization. Make room before moving instead of hitting the scroll limit.
    if(dir>0&&track.scrollLeft+distance>max+2){
      const offset=track.scrollLeft-distance;
      track.style.scrollSnapType='none';track.append(track.firstElementChild);track.scrollLeft=offset;
      track.getBoundingClientRect();track.style.scrollSnapType='';
    }else if(dir<0&&track.scrollLeft-distance<-2){
      const offset=track.scrollLeft+distance;
      track.style.scrollSnapType='none';track.prepend(track.lastElementChild);track.scrollLeft=offset;
      track.getBoundingClientRect();track.style.scrollSnapType='';
    }
    track.scrollBy({left:dir*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    settleTimer=window.setTimeout(settle,500);
  };
  prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
  track.addEventListener('scroll',()=>{if(adjusting)return;window.clearTimeout(settleTimer);settleTimer=window.setTimeout(settle,120)},{passive:true});
  track.addEventListener('focusout',()=>window.setTimeout(()=>{if(!moving&&!track.contains(document.activeElement))sync()},0));
  track.addEventListener('scrollend',settle);window.addEventListener('resize',sync);sync();
    }else if(track){
      const previous=kitsch.querySelector('[data-kitsch-prev]'), next=kitsch.querySelector('[data-kitsch-next]');
      const syncNavigation=()=>{const end=Math.max(0,track.scrollWidth-track.clientWidth);if(previous)previous.disabled=track.scrollLeft<=1;if(next)next.disabled=track.scrollLeft>=end-1;if(next?.disabled&&document.activeElement===next&&!previous?.disabled)previous?.focus({preventScroll:true});else if(previous?.disabled&&document.activeElement===previous&&!next?.disabled)next?.focus({preventScroll:true})};
      const move=direction=>{const cards=track.querySelectorAll('[data-kitsch-addition]');const distance=cards.length>1?Math.abs(cards[1].getBoundingClientRect().left-cards[0].getBoundingClientRect().left):track.clientWidth;track.scrollBy({left:direction*distance,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})};
      previous?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',syncNavigation,{passive:true});
      if(window.ResizeObserver){const observer=new ResizeObserver(syncNavigation);observer.observe(track);track.querySelectorAll('[data-kitsch-addition]').forEach(card=>observer.observe(card))}else window.addEventListener('resize',syncNavigation);
      syncNavigation();
    }
  kitsch.addEventListener('click',async event=>{
    const button=event.target.closest('[data-kitsch-addition-add]');
    if(!button||button.disabled)return;
    const card=button.closest('[data-kitsch-addition]');
    if(!card)return;
    const defaultLabel=button.dataset.defaultLabel||(button.dataset.defaultLabel=button.textContent);
    let status=card.querySelector('[data-kitsch-addition-error]');
    if(!status){status=document.createElement('p');status.dataset.kitschAdditionError='';status.className='kitsch-addition-error';status.setAttribute('role','alert');button.after(status)}
    status.textContent='';status.hidden=true;
    button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Adding…';
    let errorMessage='Could not confirm the addition. Check your cart before trying again.';
    try{
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(card.dataset.variantId),quantity:1}]})});
      if(!response.ok){
        if(response.status>=400&&response.status<500){
          errorMessage='This item could not be added. Please review your selection and try again.';
          try{const error=await response.json();const detail=error.description||error.message;if(typeof detail==='string'&&detail.trim())errorMessage=detail}catch{}
        }
        throw new Error('Cart add failed');
      }
      errorMessage='This item was added. Open your cart to review it.';
      await showAddedCart();button.textContent=defaultLabel;
    }catch{
      status.hidden=false;status.textContent=errorMessage;button.textContent=defaultLabel;
    }finally{button.disabled=false;button.removeAttribute('aria-busy')}
  });
  }
  if(toggle&&nav){
    // Fit the Red menu below its actual header, including the shortcut row.
    if(toggle.closest('.site-header--red')){
      const fitMenu=()=>{
        if(getComputedStyle(toggle).display==='none'){
          nav.style.removeProperty('height');nav.style.removeProperty('max-height');return;
        }
        const viewport=window.visualViewport;
        const bottom=viewport?viewport.offsetTop+viewport.height:window.innerHeight;
        const height=Math.max(0,bottom-nav.getBoundingClientRect().top);
        nav.style.height=`${height}px`;nav.style.maxHeight=`${height}px`;
      };
      toggle.addEventListener('click',fitMenu);
      window.addEventListener('resize',fitMenu);
      window.addEventListener('scroll',fitMenu,{passive:true});
      window.visualViewport?.addEventListener('resize',fitMenu);
      window.visualViewport?.addEventListener('scroll',fitMenu);
      new ResizeObserver(fitMenu).observe(toggle.closest('.site-header--red'));
      fitMenu();
    }
    const closeMenu=()=>{
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded','false');
      document.body.classList.remove('menu-open');
    };
    nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape'&&nav.classList.contains('is-open')){closeMenu();toggle.focus()}
    });
    // Use the rendered toggle so each theme's actual breakpoint stays authoritative.
    const syncMenuBreakpoint=()=>{
      if(!nav.classList.contains('is-open')||getComputedStyle(toggle).display!=='none')return;
      const focusHidden=nav.contains(document.activeElement)||document.activeElement===toggle;
      closeMenu();
      if(focusHidden)toggle.closest('header')?.querySelector('.brand-mark')?.focus();
    };
    window.addEventListener('resize',syncMenuBreakpoint);
    syncMenuBreakpoint();
  }
  const strip=document.querySelector('.customer-strip');if(strip){const distance=()=>Math.max(1,strip.querySelector('.strip-review')?.getBoundingClientRect().width||strip.clientWidth);document.querySelector('[data-strip-prev]')?.addEventListener('click',()=>strip.scrollBy({left:-distance(),behavior:'smooth'}));document.querySelector('[data-strip-next]')?.addEventListener('click',()=>strip.scrollBy({left:distance(),behavior:'smooth'}))}
  document.querySelectorAll('[data-catalog-featured-reviews]').forEach(carousel=>{const track=carousel.querySelector('[data-catalog-featured-reviews-track]');const next=carousel.querySelector('[data-catalog-featured-reviews-next]');if(!track||!next)return;const step=()=>track.querySelector('.lohriz-featured-review')?.getBoundingClientRect().width||track.clientWidth;const move=direction=>{const atStart=track.scrollLeft<=2;const atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;if(direction>0&&atEnd)track.scrollTo({left:0,behavior:'smooth'});else if(direction<0&&atStart)track.scrollTo({left:track.scrollWidth,behavior:'smooth'});else track.scrollBy({left:direction*step(),behavior:'smooth'})};next.addEventListener('click',()=>move(1));track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();move(1)}if(event.key==='ArrowLeft'){event.preventDefault();move(-1)}})})
  document.querySelectorAll('[data-lohriz-product-info]').forEach(productInfo=>{
    if(productInfo.dataset.bound==='true')return;
    productInfo.dataset.bound='true';
    const entries=[];
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    const finish=entry=>{
      if(entry.animation){entry.animation.onfinish=null;entry.animation.cancel();entry.animation=null}
      entry.panel.hidden=!entry.open;entry.panel.inert=!entry.open;
      entry.item.style.height='';entry.item.style.overflow='';
    };
    const change=(entry,open)=>{
      const start=entry.item.getBoundingClientRect().height;
      if(entry.animation){entry.animation.onfinish=null;entry.animation.cancel();entry.animation=null}
      entry.open=open;entry.trigger.setAttribute('aria-expanded',String(open));
      if(!open&&entry.panel.contains(document.activeElement))entry.trigger.focus({preventScroll:true});
      entry.panel.inert=!open;
      if(reduced.matches||typeof entry.item.animate!=='function'){finish(entry);return}
      entry.panel.hidden=!open;
      const end=entry.item.getBoundingClientRect().height;
      entry.panel.hidden=false;entry.item.style.overflow='hidden';
      const animation=entry.item.animate([{height:`${start}px`},{height:`${end}px`}],{duration:300,easing:'ease-in-out'});
      entry.animation=animation;
      animation.onfinish=()=>{if(entry.animation===animation)finish(entry)};
    };
    productInfo.querySelectorAll('.lohriz-product-info__trigger').forEach(trigger=>{
      const panel=document.getElementById(trigger.getAttribute('aria-controls'));
      if(!panel)return;
      const entry={trigger,panel,item:trigger.closest('.lohriz-product-info__item'),open:!panel.hidden,animation:null};
      entries.push(entry);panel.inert=!entry.open;
      const togglePanel=()=>{const open=!entry.open;if(open)entries.forEach(other=>{if(other!==entry&&other.open)change(other,false)});change(entry,open)};
      trigger.addEventListener('click',togglePanel);
      trigger.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();togglePanel()}});
    });
    const settle=()=>entries.forEach(finish);
    window.addEventListener('resize',settle);
    reduced.addEventListener?.('change',settle);
    const openFromHash=()=>{const itemId=window.location.hash.slice(1);if(!itemId)return;const item=productInfo.querySelector(`#${CSS.escape(itemId)}`);const trigger=item?.querySelector('.lohriz-product-info__trigger');if(!trigger)return;if(trigger.getAttribute('aria-expanded')!=='true')trigger.click();window.setTimeout(()=>item.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}),0)};
    openFromHash();
    window.addEventListener('hashchange',openFromHash);
  });
  const quiz=document.querySelector('[data-match-quiz]');if(quiz){let quizTimer;const panels=Array.from(quiz.querySelectorAll('[data-quiz-panel]'));const showPanel=name=>panels.forEach(panel=>panel.classList.toggle('is-active',panel.dataset.quizPanel===name));const openQuiz=()=>{window.clearTimeout(quizTimer);showPanel('mission');quiz.hidden=false;quiz.setAttribute('aria-hidden','false');requestAnimationFrame(()=>quiz.classList.add('is-open'));document.body.classList.add('quiz-open')};const closeQuiz=()=>{window.clearTimeout(quizTimer);quiz.classList.remove('is-open');quiz.setAttribute('aria-hidden','true');document.body.classList.remove('quiz-open');window.setTimeout(()=>{quiz.hidden=true},220)};document.querySelector('[data-quiz-open]')?.addEventListener('click',openQuiz);quiz.querySelectorAll('[data-quiz-close]').forEach(button=>button.addEventListener('click',closeQuiz));quiz.querySelectorAll('[data-quiz-mission]').forEach(button=>button.addEventListener('click',()=>showPanel('fuel')));quiz.querySelectorAll('[data-quiz-fuel]').forEach(button=>button.addEventListener('click',()=>{showPanel('loading');quizTimer=window.setTimeout(()=>showPanel('result'),900)}));quiz.querySelector('[data-quiz-again]')?.addEventListener('click',()=>showPanel('mission'));document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!quiz.hidden)closeQuiz()})}
  const reviewList=document.querySelector('[data-review-list]');if(reviewList){let cards=Array.from(reviewList.querySelectorAll('.review-card'));let masonryFrame=0,lastMasonryWidth=-1,lastMasonryColumns=0;const columnCount=()=>{const width=reviewList.clientWidth;return width>=1420?6:width>=1150?5:width>=920?4:width>=501?3:2};const buildMasonry=()=>{masonryFrame=0;const width=reviewList.clientWidth;const count=columnCount();if(width===lastMasonryWidth&&count===lastMasonryColumns&&reviewList.classList.contains('is-masonry'))return;lastMasonryWidth=width;lastMasonryColumns=count;reviewList.replaceChildren();const columns=Array.from({length:count},()=>{const column=document.createElement('div');column.className='review-column';reviewList.append(column);return column});cards.forEach(card=>columns.reduce((shortest,column)=>column.offsetHeight<shortest.offsetHeight?column:shortest,columns[0]).append(card));reviewList.classList.add('is-masonry')};const scheduleMasonry=()=>{if(masonryFrame)return;masonryFrame=window.requestAnimationFrame(buildMasonry)};reviewList.setReviewOrder=nextCards=>{cards=nextCards;scheduleMasonry()};const images=Array.from(reviewList.querySelectorAll('img'));buildMasonry();Promise.all(images.map(image=>image.complete?Promise.resolve():new Promise(resolve=>image.addEventListener('load',resolve,{once:true})))).then(scheduleMasonry);if('ResizeObserver'in window){const masonryObserver=new ResizeObserver(scheduleMasonry);masonryObserver.observe(reviewList)}else window.addEventListener('resize',scheduleMasonry,{passive:true})}
  const reviewRoot=document.querySelector('[data-rhp-review-root]');if(reviewRoot&&!["red-bull-extreme-honey","loriz-premium-shilajit-honey","premium-honey-sachets-individually-packed","php-royal-honey-supplement"].includes(reviewRoot.dataset.productHandle)){const avatarAssets=(reviewRoot.dataset.reviewAvatarAssets||'').split('|').filter(Boolean);const applyReviewAvatars=()=>{if(!avatarAssets.length)return;const targets=Array.from(reviewRoot.querySelectorAll('#judgeme_product_reviews .jdgm-rev__icon,#judgeme_product_reviews .jm-reviewer-avatar'));targets.forEach((target,index)=>{const src=avatarAssets[index%avatarAssets.length];if(target.dataset.lohrizAvatarApplied===src)return;const image=target.matches('img')?target:target.querySelector('img');if(image){image.src=src;image.removeAttribute('srcset');image.alt='';image.loading='lazy';image.decoding='async'}else{target.style.backgroundImage=`url("${src}")`;target.style.backgroundPosition='center';target.style.backgroundSize='cover';target.style.backgroundRepeat='no-repeat'}target.dataset.lohrizAvatarApplied=src})};applyReviewAvatars();const avatarObserver=new MutationObserver(applyReviewAvatars);avatarObserver.observe(reviewRoot,{childList:true,subtree:true});window.setTimeout(applyReviewAvatars,900);window.setTimeout(applyReviewAvatars,1800)}
  const reviewSortToggle=document.querySelector('[data-review-sort-toggle]');const reviewSortMenu=document.querySelector('[data-review-sort-menu]');if(reviewSortToggle&&reviewSortMenu&&reviewList){const closeReviewSort=()=>{reviewSortMenu.hidden=true;reviewSortToggle.setAttribute('aria-expanded','false')};reviewSortToggle.addEventListener('click',event=>{event.stopPropagation();const open=reviewSortMenu.hidden;closeReviewSort();if(open){reviewSortMenu.hidden=false;reviewSortToggle.setAttribute('aria-expanded','true')}});reviewSortMenu.addEventListener('click',event=>event.stopPropagation());reviewSortMenu.querySelectorAll('[data-review-sort]').forEach(button=>button.addEventListener('click',()=>{const cards=Array.from(reviewList.querySelectorAll('.review-card'));const byIndex=(a,b)=>Number(a.dataset.reviewIndex)-Number(b.dataset.reviewIndex);if(button.dataset.reviewSort==='newest'||button.dataset.reviewSort==='lowest')cards.sort((a,b)=>byIndex(b,a));else if(button.dataset.reviewSort==='photo')cards.sort((a,b)=>Number(b.dataset.hasPhoto==='true')-Number(a.dataset.hasPhoto==='true')||byIndex(a,b));else cards.sort(byIndex);reviewList.setReviewOrder?.(cards);closeReviewSort()}));document.addEventListener('click',closeReviewSort);document.addEventListener('keydown',event=>{if(event.key==='Escape')closeReviewSort()})}
  document.querySelectorAll('.review-pagination button').forEach(button=>button.addEventListener('click',()=>{button.parentElement.querySelectorAll('button').forEach(item=>{item.classList.toggle('is-active',item===button);item.removeAttribute('aria-current')});button.setAttribute('aria-current','page')}));
  const reviewModal=document.querySelector('[data-review-modal]');if(reviewModal){let reviewTimer;let reviewRating=0;const reviewForm=reviewModal.querySelector('[data-review-form]');const ratingButtons=reviewModal.querySelectorAll('[data-review-rating]');const closeReviewModal=()=>{window.clearTimeout(reviewTimer);reviewModal.classList.remove('is-open');reviewModal.setAttribute('aria-hidden','true');document.body.classList.remove('review-open');window.setTimeout(()=>{reviewModal.hidden=true},200)};const openReviewModal=()=>{window.clearTimeout(reviewTimer);reviewModal.hidden=false;reviewModal.setAttribute('aria-hidden','false');requestAnimationFrame(()=>reviewModal.classList.add('is-open'));document.body.classList.add('review-open');reviewModal.querySelector('[data-review-rating]')?.focus()};document.querySelector('[data-review-open]')?.addEventListener('click',openReviewModal);reviewModal.querySelectorAll('[data-review-close]').forEach(button=>button.addEventListener('click',closeReviewModal));ratingButtons.forEach(button=>button.addEventListener('click',()=>{reviewRating=Number(button.dataset.reviewRating);ratingButtons.forEach(item=>item.classList.toggle('is-active',Number(item.dataset.reviewRating)<=reviewRating))}));reviewForm?.addEventListener('submit',event=>{event.preventDefault();if(!reviewRating){ratingButtons[0]?.focus();return}const submit=reviewForm.querySelector('button[type="submit"]');submit.textContent=document.documentElement.lang.startsWith('es')?'Gracias':'Thank you';submit.classList.add('is-sent');reviewTimer=window.setTimeout(()=>{closeReviewModal();reviewForm.reset();reviewRating=0;ratingButtons.forEach(item=>item.classList.remove('is-active'));submit.classList.remove('is-sent');submit.textContent=document.documentElement.lang.startsWith('es')?'Enviar reseña':'Submit review'},900)});document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!reviewModal.hidden)closeReviewModal()})}
  const reviewLightbox=document.querySelector('[data-review-lightbox-modal]');
  const spanish=document.documentElement.lang.toLowerCase().startsWith('es');
  if(reviewLightbox){
    const lightboxImage=reviewLightbox.querySelector('img');
    const reviewContent=document.createElement('div');reviewContent.className='review-lightbox-content';
    reviewLightbox.append(reviewContent);reviewContent.append(lightboxImage);
    // Key events inside a cross-origin player do not bubble to this document.
    // A trailing focus stop also catches Tab when it leaves the player.
    const mediaFocusEnd=document.createElement('span');
    mediaFocusEnd.tabIndex=0;mediaFocusEnd.className='visually-hidden';
    mediaFocusEnd.dataset.reviewFocusEnd='';
    mediaFocusEnd.addEventListener('focus',()=>reviewLightbox.querySelector('[data-review-lightbox-close]')?.focus({preventScroll:true}));
    reviewLightbox.append(mediaFocusEnd);
    const reviewDetails=document.createElement('article');reviewDetails.className='review-lightbox-details';reviewDetails.tabIndex=0;reviewDetails.setAttribute('aria-label','Photo review');reviewDetails.hidden=true;reviewContent.append(reviewDetails);
    const previous=reviewLightbox.querySelector('[data-review-lightbox-prev]');
    const next=reviewLightbox.querySelector('[data-review-lightbox-next]');
    const count=reviewLightbox.querySelector('[data-review-lightbox-count]');
    const imageError=document.createElement('div');
    imageError.className='review-lightbox-error';imageError.hidden=true;imageError.setAttribute('role','status');
    const imageErrorText=document.createElement('p');
    imageErrorText.textContent=document.documentElement.lang.startsWith('es')?'No se pudo cargar la imagen.':'This image could not be loaded.';
    const imageRetry=document.createElement('button');imageRetry.type='button';
    imageRetry.textContent=document.documentElement.lang.startsWith('es')?'Reintentar':'Retry image';
    imageError.append(imageErrorText,imageRetry);reviewContent.append(imageError);
    const prepareImage=()=>{if(document.activeElement===imageRetry)reviewLightbox.querySelector('[data-review-lightbox-close]')?.focus({preventScroll:true});imageError.hidden=true;imageRetry.hidden=true;lightboxImage.hidden=false;reviewLightbox.setAttribute('aria-busy','true')};
    lightboxImage.addEventListener('load',()=>{if(videoFrame)return;imageError.hidden=true;imageRetry.hidden=true;lightboxImage.hidden=false;reviewLightbox.setAttribute('aria-busy','false')});
    lightboxImage.addEventListener('error',()=>{if(videoFrame)return;lightboxImage.hidden=true;imageError.hidden=false;imageRetry.hidden=false;reviewLightbox.setAttribute('aria-busy','false')});
    imageRetry.hidden=true;
    imageRetry.addEventListener('click',()=>{prepareImage();reviewLightbox.querySelector('[data-review-lightbox-close]')?.focus({preventScroll:true});lightboxImage.src=images[imageIndex]});
    let images=[];
    let mediaItems=[];
    let videoFrame=null;
    const stopReviewVideo=()=>{videoFrame?.remove();videoFrame=null;};
    let photoReviews=[];
    const thumbnails=document.createElement('nav');thumbnails.className='review-lightbox-thumbnails';thumbnails.setAttribute('aria-label','Customer photo thumbnails');thumbnails.hidden=true;reviewContent.append(thumbnails);
    const buildThumbnails=()=>{
      thumbnails.replaceChildren();thumbnails.hidden=!photoReviews.some(Boolean)||images.length<2;
      if(thumbnails.hidden)return;
      images.forEach((src,index)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`View ${mediaItems[index]?.type==='video'?'video':'photo'} ${index+1} of ${images.length}`);button.dataset.reviewMediaType=mediaItems[index]?.type||'image';button.dataset.imageSrc=src;const image=document.createElement('img');image.src=mediaItems[index]?.thumbnail||src;image.alt='';image.loading='lazy';if(mediaItems[index]?.type==='video')image.addEventListener('error',()=>{image.style.visibility='hidden'});button.append(image);if(mediaItems[index]?.type==='video'){const play=document.createElement('span');play.className='rhp-media-play';play.textContent='▶';play.setAttribute('aria-hidden','true');button.append(play)}button.addEventListener('click',()=>showLightboxImage(index));thumbnails.append(button)});
    };
    const renderPhotoReview=record=>{
      const spanish=document.documentElement.lang.startsWith('es');
      reviewDetails.replaceChildren();reviewDetails.hidden=!record;
      reviewLightbox.classList.toggle('has-review-details',Boolean(record));
      if(!record)return;
      const identity=document.createElement('div');identity.className='review-lightbox-identity';
      const name=String(record.reviewer_name||'Customer').trim()||'Customer';
      const initials=window.rhpReviewMedia?.initials(name)||Array.from(name)[0].toLocaleUpperCase();
      const avatar=document.createElement('span');avatar.className='review-lightbox-avatar';avatar.textContent=initials;avatar.setAttribute('aria-hidden','true');
      window.rhpReviewMedia?.mountAvatar(avatar,record.avatar_image_url);
      const identityText=document.createElement('div');identityText.className='review-lightbox-identity-text';
      const author=document.createElement('strong');author.className='review-lightbox-author';author.textContent=name;identityText.append(author);
      if(record.verified_buyer===true){const verified=document.createElement('span');verified.className='review-lightbox-verified';verified.textContent=document.documentElement.lang.startsWith('es')?'Comprador verificado':'Verified Buyer';const check=document.createElement('span');check.className='review-lightbox-verification-icon';check.textContent='✓';check.setAttribute('aria-hidden','true');verified.append(check);identityText.append(verified);}
      identity.append(avatar,identityText);reviewDetails.append(identity);
      const score=Math.max(0,Math.min(5,Number(record.rating)||0));
      if(score){const stars=document.createElement('div');stars.className='review-lightbox-stars';stars.textContent='★'.repeat(Math.floor(score))+'☆'.repeat(5-Math.floor(score));stars.setAttribute('role','img');stars.setAttribute('aria-label',score+(spanish?' de 5 estrellas':' out of 5 stars'));reviewDetails.append(stars);}
      if(record.title){const title=document.createElement('h2');title.textContent=record.title;reviewDetails.append(title);}
      const body=document.createElement('div');body.className='review-lightbox-body';
      body.textContent=record.body_html?new DOMParser().parseFromString(record.body_html,'text/html').body.textContent:record.body||'';reviewDetails.append(body);
      if(record.uuid&&document.querySelector('[data-rhp-review-root]:is([data-product-handle="red-bull-extreme-honey"],:is([data-product-handle="loriz-premium-shilajit-honey"],[data-product-handle="premium-honey-sachets-individually-packed"],[data-product-handle="php-royal-honey-supplement"]))')){
        const votes=document.createElement('div');votes.className='review-lightbox-votes';votes.dataset.reviewVotes=record.uuid;
        const label=document.createElement('span');label.textContent=spanish?'¿Te resultó útil?':'Was this helpful?';votes.append(label);
        for(const direction of ['up','down']){const button=document.createElement('button');button.type='button';button.dataset.rhpVote=direction;button.setAttribute('aria-label',spanish?(direction==='up'?'Esta reseña fue útil':'Esta reseña no fue útil'):(direction==='up'?'This review was helpful':'This review was not helpful'));button.append(direction==='up'?(spanish?'Sí ':'Yes '):'No ');const count=document.createElement('span');count.dataset.voteCount=direction;count.textContent=String(Math.max(0,Number(record[direction==='up'?'thumb_up':'thumb_down'])||0));button.append(count);votes.append(button)}
        const status=document.createElement('span');status.dataset.voteStatus='';status.setAttribute('role','status');votes.append(status);reviewDetails.append(votes);
        document.dispatchEvent(new Event('lohriz:review-votes-rendered'));
      }
      reviewDetails.scrollTop=0;
    };
    let imageIndex=0;
    let galleryTrigger=null;
    let touchStartX=0;
    let touchStartY=0;
    let zoomScale=1,panX=0,panY=0,panStart=null;
    const zoomTouches=new Map();let pinchStart=null,suppressSwipe=false;
    const pinchGeometry=()=>{const [a,b]=[...zoomTouches.values()];return {distance:Math.hypot(b.x-a.x,b.y-a.y),x:(a.x+b.x)/2,y:(a.y+b.y)/2}};
    const zoomButton=document.createElement('button');
    zoomButton.type='button';zoomButton.className='review-lightbox-zoom';zoomButton.hidden=true;
    reviewLightbox.append(zoomButton);
    const applyZoom=()=>{
      const width=lightboxImage.offsetWidth,height=lightboxImage.offsetHeight;
      panX=Math.max(-width*(zoomScale-1)/2,Math.min(width*(zoomScale-1)/2,panX));
      panY=Math.max(-height*(zoomScale-1)/2,Math.min(height*(zoomScale-1)/2,panY));
      lightboxImage.style.transform=zoomScale===1?'':`translate(${panX}px,${panY}px) scale(${zoomScale})`;
      reviewLightbox.classList.toggle('is-zoomed',zoomScale>1);
      zoomButton.textContent=zoomScale>1?'−':'+';
      zoomButton.setAttribute('aria-label',zoomScale>1?'Zoom out':'Zoom in');
      zoomButton.setAttribute('aria-pressed',String(zoomScale>1));
    };
    const resetZoom=()=>{zoomScale=1;panX=0;panY=0;panStart=null;pinchStart=null;zoomTouches.clear();applyZoom()};
    const toggleZoom=()=>{if(zoomButton.hidden)return;zoomScale=zoomScale===1?2:1;panX=0;panY=0;applyZoom()};
    zoomButton.addEventListener('click',toggleZoom);
    lightboxImage.addEventListener('dblclick',toggleZoom);
    lightboxImage.addEventListener('dragstart',event=>{if(!zoomButton.hidden)event.preventDefault()});
    lightboxImage.addEventListener('pointerdown',event=>{
      if(zoomButton.hidden)return;
      if(event.pointerType==='touch'){
        zoomTouches.set(event.pointerId,{x:event.clientX,y:event.clientY});
        lightboxImage.setPointerCapture?.(event.pointerId);
        if(zoomTouches.size===2){pinchStart={...pinchGeometry(),scale:zoomScale,panX,panY};panStart=null;suppressSwipe=true;return;}
      }
      if(zoomScale===1||!event.isPrimary||event.button!==0)return;
      event.preventDefault();panStart={id:event.pointerId,x:event.clientX,y:event.clientY,panX,panY};
      lightboxImage.setPointerCapture?.(event.pointerId);
    });
    lightboxImage.addEventListener('pointermove',event=>{
      if(zoomTouches.has(event.pointerId))zoomTouches.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(pinchStart&&zoomTouches.size>=2){
        const geometry=pinchGeometry();
        zoomScale=Math.max(1,Math.min(4,pinchStart.scale*geometry.distance/Math.max(1,pinchStart.distance)));
        panX=pinchStart.panX+geometry.x-pinchStart.x;panY=pinchStart.panY+geometry.y-pinchStart.y;
        applyZoom();return;
      }
      if(!panStart||panStart.id!==event.pointerId)return;
      panX=panStart.panX+event.clientX-panStart.x;panY=panStart.panY+event.clientY-panStart.y;applyZoom();
    });
    const endPan=event=>{
      if(panStart?.id===event.pointerId)panStart=null;
      const removed=zoomTouches.delete(event.pointerId);
      if(removed&&pinchStart&&zoomTouches.size<2){
        pinchStart=null;
        const remaining=zoomTouches.entries().next().value;
        if(remaining&&zoomScale>1)panStart={id:remaining[0],x:remaining[1].x,y:remaining[1].y,panX,panY};
      }
    };
    lightboxImage.addEventListener('pointerup',endPan);lightboxImage.addEventListener('pointercancel',endPan);
    lightboxImage.addEventListener('lostpointercapture',endPan);
    window.addEventListener('resize',()=>{if(!reviewLightbox.hidden)applyZoom()});
    const showLightboxImage=index=>{
      if(!images.length)return;
      resetZoom();
      imageIndex=(index+images.length)%images.length;
      renderPhotoReview(photoReviews[imageIndex]||null);
      reviewLightbox.scrollTop=0;
      reviewContent.scrollTop=0;
      Array.from(thumbnails.children).forEach((button,index)=>{button.setAttribute('aria-current',String(index===imageIndex));if(index===imageIndex){const left=button.offsetLeft-thumbnails.offsetLeft;thumbnails.scrollLeft=Math.max(0,left-(thumbnails.clientWidth-button.offsetWidth)/2)}});
      stopReviewVideo();
      if(mediaItems[imageIndex]?.type==='video'){
        imageError.hidden=true;imageRetry.hidden=true;lightboxImage.hidden=true;
        lightboxImage.removeAttribute('src');
        reviewLightbox.setAttribute('aria-busy','true');
        const frame=document.createElement('iframe');frame.className='review-lightbox-video';
        frame.title='Customer review video';frame.allow='fullscreen; picture-in-picture';
        frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';
        frame.addEventListener('load',()=>{if(videoFrame===frame)reviewLightbox.setAttribute('aria-busy','false')});
        videoFrame=frame;frame.src=images[imageIndex];reviewContent.prepend(frame);
      }else{prepareImage();lightboxImage.src=images[imageIndex];}
      const productThumb=galleryTrigger?.closest('[data-catalog-gallery]')?.querySelectorAll('[data-catalog-thumb]')[imageIndex];
      if(productThumb)lightboxImage.alt=productThumb.dataset.imageAlt||'Product image';
      const hasGallery=images.length>1;
      if(previous)previous.hidden=!hasGallery;
      if(next)next.hidden=!hasGallery;
      if(count){count.hidden=!hasGallery;count.textContent=hasGallery?`${imageIndex+1} / ${images.length}`:''}
      if(hasGallery&&mediaItems[(imageIndex+1)%images.length]?.type!=='video'){const preload=new Image();preload.src=images[(imageIndex+1)%images.length]}
    };
    const closeLightbox=()=>{stopReviewVideo();resetZoom();reviewLightbox.hidden=true;reviewLightbox.setAttribute('aria-hidden','true');document.body.classList.remove('review-open');if(galleryTrigger?.isConnected)galleryTrigger.focus({preventScroll:true})};
    document.addEventListener('click',event=>{
      const item=event.target.closest?.('[data-catalog-zoom], [data-review-lightbox][data-image-src], [data-rhp-review-root] .jdgm-rev__pics a');
      if(!item||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      const mediaTrack=item.closest('[data-review-media-track]');
      const reviewPhotos=item.closest('.jdgm-rev__pics');
      const productGallery=item.closest('[data-catalog-gallery]');
      const productImage=productGallery?.querySelector('[data-catalog-main-image]');
      const selectedImage=productImage?.src||item.dataset.imageSrc||item.href;
      images=productGallery?Array.from(productGallery.querySelectorAll('[data-catalog-thumb]'),thumb=>new URL(thumb.dataset.imageSrc,window.location.href).href):mediaTrack?Array.from(mediaTrack.querySelectorAll('[data-image-src]'),photo=>photo.dataset.imageSrc):reviewPhotos?Array.from(reviewPhotos.querySelectorAll('a[href]'),photo=>photo.href):[item.dataset.imageSrc,item.dataset.imageExtraSrc].filter(Boolean);
      const sourceItems=mediaTrack?Array.from(mediaTrack.querySelectorAll('[data-image-src]')):reviewPhotos?Array.from(reviewPhotos.querySelectorAll('a[href]')):[];
      mediaItems=images.map((src,index)=>({type:sourceItems[index]?.dataset.reviewMediaType||'image',src,thumbnail:sourceItems[index]?.dataset.mediaThumbnail||src}));
      const reviewRow=reviewPhotos?.closest('.jdgm-rev');
      const rowRecord=reviewRow?{avatar_image_url:{normal:reviewRow.querySelector('[data-review-avatar-normal]')?.dataset.reviewAvatarNormal,retina:reviewRow.querySelector('[data-review-avatar-normal]')?.dataset.reviewAvatarRetina},reviewer_name:reviewRow.querySelector('.jdgm-rev__author')?.textContent,rating:reviewRow.querySelector('.jdgm-rev__rating')?.dataset.score,title:reviewRow.querySelector('.jdgm-rev__title')?.textContent,body:reviewRow.querySelector('.jdgm-rev__body > p, .jdgm-rev__body .rhp-review-read-more > p')?.textContent??reviewRow.querySelector('.jdgm-rev__body')?.textContent,verified_buyer:!!reviewRow.querySelector('.rhp-review-status.is-verified')}:null;
      const rowVotes=reviewRow?.querySelector('[data-review-votes]');
      if(rowRecord&&rowVotes){rowRecord.uuid=rowVotes.dataset.reviewVotes;rowRecord.thumb_up=Number(rowVotes.querySelector('[data-vote-count="up"]')?.textContent)||0;rowRecord.thumb_down=Number(rowVotes.querySelector('[data-vote-count="down"]')?.textContent)||0;}
      photoReviews=productGallery?[]:mediaTrack?Array.from(mediaTrack.querySelectorAll('[data-image-src]'),photo=>photo.rhpSourceReview||null):images.map(()=>rowRecord);
      if(!images.length&&selectedImage)images=[selectedImage];
      if(!images.length)return;
      event.preventDefault();
      galleryTrigger=item;
      buildThumbnails();
      const hasVideo=mediaItems.some(media=>media.type==='video');
      previous?.setAttribute('aria-label',spanish?(hasVideo?'Contenido multimedia anterior':'Foto anterior'):(hasVideo?'Previous media':'Previous photo'));
      next?.setAttribute('aria-label',spanish?(hasVideo?'Siguiente contenido multimedia':'Foto siguiente'):(hasVideo?'Next media':'Next photo'));
      thumbnails.setAttribute('aria-label',spanish?(hasVideo?'Miniaturas de contenido multimedia de clientes':'Miniaturas de fotos de clientes'):(hasVideo?'Customer media thumbnails':'Customer photo thumbnails'));
      zoomButton.hidden=!productGallery;
      reviewLightbox.classList.toggle('is-product-gallery',Boolean(productGallery));
      lightboxImage.alt=productImage?.alt||'Customer product photo';
      reviewLightbox.setAttribute('role','dialog');
      reviewLightbox.setAttribute('aria-modal','true');
      reviewLightbox.setAttribute('aria-label',productGallery?'Product image gallery':mediaItems.some(media=>media.type==='video')?'Customer photos and videos':'Customer photos');
      showLightboxImage(Math.max(0,images.indexOf(selectedImage)));
      reviewLightbox.hidden=false;
      reviewLightbox.scrollTop=0;
      reviewContent.scrollTop=0;
      reviewLightbox.setAttribute('aria-hidden','false');
      document.body.classList.add('review-open');
      reviewLightbox.querySelector('[data-review-lightbox-close]')?.focus({preventScroll:true});
    });
    previous?.addEventListener('click',()=>showLightboxImage(imageIndex-1));
    next?.addEventListener('click',()=>showLightboxImage(imageIndex+1));
    reviewLightbox.querySelector('[data-review-lightbox-close]')?.addEventListener('click',closeLightbox);
    reviewLightbox.addEventListener('click',event=>{if(event.target===reviewLightbox)closeLightbox()});
    reviewLightbox.addEventListener('touchstart',event=>{
      if(event.target.closest('.review-lightbox-thumbnails,.review-lightbox-details')){suppressSwipe=true;return;}
      if(!event.touches||event.touches.length===1)suppressSwipe=false;
      if(event.touches?.length>1)suppressSwipe=true;
      const touch=event.changedTouches[0];
      if(touch){touchStartX=touch.clientX;touchStartY=touch.clientY}
    },{passive:true});
    reviewLightbox.addEventListener('touchend',event=>{
      const touch=event.changedTouches[0];
      if(!touch||images.length<2||zoomScale>1||suppressSwipe)return;
      const deltaX=touch.clientX-touchStartX;
      const deltaY=touch.clientY-touchStartY;
      if(Math.abs(deltaX)<45||Math.abs(deltaX)<=Math.abs(deltaY))return;
      showLightboxImage(imageIndex+(deltaX<0?1:-1));
    },{passive:true});
    document.addEventListener('keydown',event=>{
      if(reviewLightbox.hidden)return;
      if(!zoomButton.hidden&&['+','=','-','0'].includes(event.key)){event.preventDefault();if(event.key==='-'||event.key==='0')resetZoom();else if(zoomScale===1)toggleZoom();}
      if(event.key==='Tab'){
        const controls=Array.from(reviewLightbox.querySelectorAll('button,iframe,[tabindex="0"]')).filter(button=>!button.hasAttribute('data-review-focus-end')&&!button.hidden&&!button.disabled&&button.getClientRects().length>0);
        const first=controls[0],last=controls[controls.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus()}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus()}
      }
      if(['Escape','ArrowLeft','ArrowRight'].includes(event.key))event.preventDefault();
      if(event.key==='Escape')closeLightbox();
      if(event.key==='ArrowLeft'&&images.length>1)showLightboxImage(imageIndex-1);
      if(event.key==='ArrowRight'&&images.length>1)showLightboxImage(imageIndex+1);
    });
  }
  const revealItems=document.querySelectorAll('.match-banner>div,.offer-band>.offer-image,.offer-band>.offer-copy,.regular-honey>*,.ingredient-heading>*,.ingredient-grid,.ingredient-grid>article,.split-section>*,.simple-use>*,.shipping-section>*,.reviews-widget');if('IntersectionObserver'in window){revealItems.forEach(item=>item.classList.add('reveal-pending'));const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('reveal-pending');entry.target.classList.add('reveal-visible');observer.unobserve(entry.target)}}),{threshold:.08});revealItems.forEach(item=>observer.observe(item))}
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',rhpInitialize,{once:true});else rhpInitialize();
document.addEventListener('shopify:section:load',event=>rhpInitializeReasons(event.target));
const rhpSyncProductAggregate=()=>document.querySelectorAll('[data-product-aggregate]').forEach(target=>{
  const root=document.querySelector('[data-rhp-review-root]');
  const spanish=document.documentElement.lang.toLowerCase().startsWith('es');
  const score=Number(root?.querySelector('[data-review-score]')?.textContent||0);
  const count=Number(root?.dataset.reviewCount||0);
  const ratingNode=target.querySelector('[data-product-rating]');
  const countNode=target.querySelector('[data-product-review-count]');
  const stars=target.querySelector('.catalog-aggregate-rating__stars');
  const valid=Number.isFinite(score)&&score>0&&score<=5&&Number.isInteger(count)&&count>0;
  if(valid){
    if(ratingNode)ratingNode.textContent=score.toFixed(1);
    if(countNode)countNode.textContent=spanish?`${count} reseñas`:`${count} reviews`;
    if(stars){
      stars.style.setProperty('--aggregate-rating-percent',`${score*20}%`);
      // Match the SVG's 14.6-unit stars and 1.647-unit gaps when clipping a fractional star.
      const full=Math.floor(score),fraction=score-full;
      const filled=full*16.24705882352941+(fraction?fraction*14.6:-1.64705882352941);
      stars.style.setProperty('--aggregate-star-fill-percent',`${Math.min(100,Math.max(0,filled/79.58823529411765*100))}%`);
    }
    const link=target.querySelector('a');
    if(link)link.setAttribute('aria-label',spanish?`Calificación de ${score} de 5 estrellas, ${count} reseñas. Ver reseñas de clientes`:`Rated ${score} out of 5 stars, ${count} reviews. View customer reviews`);
  }
  target.hidden=!valid;
});
rhpSyncProductAggregate();
document.querySelectorAll('[data-rhp-review-root]').forEach(root=>new MutationObserver(rhpSyncProductAggregate).observe(root,{attributes:true,childList:true,subtree:true}));

document.querySelectorAll('[data-best-selling-bundles]').forEach(root=>{
  const showAddedCart=async()=>{
    try{if(typeof window.rhpCartRefresh!=='function'||typeof window.rhpCartOpen!=='function'){window.location.assign('/cart');return}await window.rhpCartRefresh();await window.rhpCartOpen();}
    catch(error){window.location.assign('/cart');}
  };
  const track=root.querySelector('[data-best-selling-track]');
  if(!track)return;
  const cards=()=>[...root.querySelectorAll('[data-best-selling-card]')];
  const originalCards=cards(),prev=root.querySelector('[data-best-selling-prev]'),next=root.querySelector('[data-best-selling-next]');
  let settleTimer,moving=false,adjusting=false;
  const stride=()=>{const c=cards();return c[1]?c[1].getBoundingClientRect().left-c[0].getBoundingClientRect().left:0};
  const canLoop=()=>originalCards.length>1&&track.scrollWidth-track.clientWidth>2;
  const rotate=()=>{
    if(adjusting||!canLoop()||track.contains(document.activeElement))return;
    const distance=stride();if(distance<=0)return;
    const index=Math.round(track.scrollLeft/distance);
    if(index===1)return;
    const offset=track.scrollLeft+(1-index)*distance,active=document.activeElement;
    adjusting=true;track.style.scrollSnapType='none';
    // Move existing cards so the visible card always has a neighbor on each side.
    // Keeping the actual nodes preserves selections and cart feedback without duplicate IDs.
    if(index<1)track.prepend(track.lastElementChild);
    else for(let i=1;i<index;i++)track.append(track.firstElementChild);
    track.scrollLeft=offset;
    if(active&&track.contains(active)&&document.activeElement!==active)active.focus({preventScroll:true});
    window.requestAnimationFrame(()=>{track.style.scrollSnapType='';adjusting=false});
  };
  const settle=()=>{window.clearTimeout(settleTimer);moving=false;rotate()};
  const sync=()=>{
    window.clearTimeout(settleTimer);moving=false;
    const enabled=canLoop();if(prev)prev.disabled=!enabled;if(next)next.disabled=!enabled;
    if(enabled)rotate();
    else if(!track.contains(document.activeElement)){
      const active=document.activeElement;
      originalCards.forEach(card=>track.append(card));track.scrollLeft=0;
      if(active&&track.contains(active)&&document.activeElement!==active)active.focus({preventScroll:true});
    }
  };
  const move=dir=>{
    if(!canLoop()||moving||adjusting)return;
    const distance=stride();if(distance<=0)return;
    moving=true;
    const max=track.scrollWidth-track.clientWidth;
    // With only one more card than fits, there is no spare neighbor after
    // normalization. Make room before moving instead of hitting the scroll limit.
    if(dir>0&&track.scrollLeft+distance>max+2){
      const offset=track.scrollLeft-distance;
      track.style.scrollSnapType='none';track.append(track.firstElementChild);track.scrollLeft=offset;
      track.getBoundingClientRect();track.style.scrollSnapType='';
    }else if(dir<0&&track.scrollLeft-distance<-2){
      const offset=track.scrollLeft+distance;
      track.style.scrollSnapType='none';track.prepend(track.lastElementChild);track.scrollLeft=offset;
      track.getBoundingClientRect();track.style.scrollSnapType='';
    }
    track.scrollBy({left:dir*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    settleTimer=window.setTimeout(settle,500);
  };
  prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
  track.addEventListener('scroll',()=>{if(adjusting)return;window.clearTimeout(settleTimer);settleTimer=window.setTimeout(settle,120)},{passive:true});
  track.addEventListener('focusout',()=>window.setTimeout(()=>{if(!moving&&!track.contains(document.activeElement))sync()},0));
  track.addEventListener('scrollend',settle);window.addEventListener('resize',sync);sync();
  root.addEventListener('click',async event=>{
    const button=event.target.closest('[data-best-selling-add]');
    if(!button||button.disabled)return;
    const card=button.closest('[data-best-selling-card]');
    if(!card)return;
    const defaultLabel=button.dataset.defaultLabel||(button.dataset.defaultLabel=button.textContent);
    let status=card.querySelector('[data-best-selling-error]');
    if(!status){status=document.createElement('p');status.dataset.bestSellingError='';status.className='lohriz-best-selling__error';status.setAttribute('role','alert');button.after(status)}
    status.textContent='';status.hidden=true;
    button.disabled=true;button.setAttribute('aria-busy','true');button.textContent='Adding…';
    let errorMessage='Could not confirm the addition. Check your cart before trying again.';
    try{
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(card.dataset.variantId),quantity:1}]})});
      if(!response.ok){
        if(response.status>=400&&response.status<500){
          errorMessage='This item could not be added. Please review your selection and try again.';
          try{const error=await response.json();const detail=error.description||error.message;if(typeof detail==='string'&&detail.trim())errorMessage=detail}catch{}
        }
        throw new Error('Cart add failed');
      }
      errorMessage='This item was added. Open your cart to review it.';
      await showAddedCart();button.textContent=defaultLabel;
    }catch{
      status.hidden=false;status.textContent=errorMessage;button.textContent=defaultLabel;
    }finally{button.disabled=false;button.removeAttribute('aria-busy')}
  });
});

/* Real pack selections for recommendation cards. */
(()=>{
  document.addEventListener('click',event=>{
    const choice=event.target.closest('[data-card-variant]');
    if(!choice||choice.disabled)return;
    const card=choice.closest('[data-kitsch-addition],[data-best-selling-card]');
    if(!card)return;
    card.dataset.variantId=choice.dataset.cardVariant;
    const discount=card.querySelector('[data-card-discount]');
    if(discount){const percent=Number(choice.dataset.cardDiscount)||0;discount.textContent=percent+'% OFF';discount.hidden=percent<=0;}
    card.querySelectorAll('[data-card-variant]').forEach(button=>{button.setAttribute('aria-checked',String(button===choice));button.tabIndex=button===choice?0:-1});
    card.querySelectorAll('a').forEach(link=>link.href=choice.dataset.cardUrl+(link.hasAttribute('data-card-review-link')?'#rhp-product-reviews':''));
    const price=card.querySelector('.kitsch-addition-price,.lohriz-best-selling__price');
    if(price){price.replaceChildren(document.createTextNode(choice.dataset.cardPrice));if(choice.dataset.cardCompare){const compare=document.createElement('s');compare.textContent=choice.dataset.cardCompare;price.append(' ',compare)}}
  });
})();

/* Keyboard selection for recommendation radio groups. */
document.addEventListener('keydown',event=>{
 const choice=event.target.closest('[data-card-variant]');
 if(!choice||!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key))return;
 const group=choice.closest('[data-card-variants]');if(!group)return;
 const choices=[...group.querySelectorAll('[data-card-variant]:not(:disabled)')];if(!choices.length)return;
 event.preventDefault();const index=choices.indexOf(choice),step=['ArrowLeft','ArrowUp'].includes(event.key)?-1:1;
 const target=choices[event.key==='Home'?0:event.key==='End'?choices.length-1:(index+step+choices.length)%choices.length];
 target.focus({preventScroll:true});target.click();
});
